import React, { useState, useRef, useEffect } from "react"
import Modal from "react-bootstrap/Modal"
import { useParams, withRouter, useHistory } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
import Select from "react-select"
import {
  Row,
  Col,
  Input,
  Label,
  Button,
  Table,
  UncontrolledTooltip,
  Spinner,
  Nav,
  Badge,
} from "reactstrap"
import { isEmpty, get, isNaN } from "lodash"
import PropTypes from "prop-types"
import moment from "moment"
import { toast } from "react-toastify"
import SimpleReactValidator from "simple-react-validator"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as alterAction from "../../store/YWx0ZXIgcXVvdGU/actions"
import * as eventAction from "../../store/zXZlbnQq/actions"
import * as followupAction from "../../store/Zm9sbG93dXA/actions"
import clientAction from "../../store/Y2xpZW50/actions"

const QuotationDetails = (props) => {
  const { dispatch, clientProfile, location, clientId } = props

  const leadClientId = !isEmpty(clientId)
    ? clientId
    : location && location.state && location.state.row
    ? location.state.row.clientId
    : []

  const companyDetails =
    !isEmpty(clientProfile) && clientProfile ? clientProfile[0].companyId : []
  const companyNameDetails =
    !isEmpty(clientProfile) && clientProfile ? clientProfile[0].company : ""
  const branchDetails =
    !isEmpty(clientProfile) && clientProfile ? clientProfile[0].branchId : []
  const segmentId =
    !isEmpty(clientProfile) && clientProfile ? clientProfile[0].segmentId : []

  const companyId = [companyDetails]
  const companyName = companyNameDetails
  const branchId = [branchDetails]

  console.log("branchId --> ", branchId)
  const [pageLoad, setPageload] = useState(false)

  //Event venu, venue locations states
  const [eventAddDetails, setEventAddDetails] = useState(false)
  const [deliverableAddDetails, setDeliverableAddDetails] = useState(false)
  const [serviceEventId, setServiceEventId] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [newVenue, setNewVenue] = useState("")
  const [venueAdd, setVenueAdd] = useState(false)
  const [addedVenue, setAddedVenue] = useState(false)
  const [newVenueLocation, setNewVenueLocation] = useState("")
  const [venueLocationAdd, setVenueLocationAdd] = useState(false)
  const [addedVenueLocation, setAddedVenueLocation] = useState(false)
  const [isMainEvent, setIsMainEvent] = useState(false)
  let { id } = useParams()
  const specificDispatch = useDispatch()
  const history = useHistory()
  console.log(history, "history")
  var leadId = id
  var status = 1
  useEffect(() => {
    setTimeout(() => {
      dispatch(quotationAction.loadRecordQuotationDetails(id))
      dispatch(quotationAction.loadServiceTotal(id))
      dispatch(quotationAction.loadDeliverableDetails(id))
      dispatch(quotationAction.loadInstructions(id))
      dispatch(quotationAction.loadPhotography(id))

      dispatch(quotationAction.loadQuotationList(id))
      dispatch(quotationAction.loadQCLayoutMaster(companyId))
      dispatch(quotationAction.loadQCLayoutSegment())
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
    }, 1000)
  }, pageLoad)

  useEffect(() => {
    if (eventAddDetails === true) {
      dispatch(quotationAction.loadRecordsMetaData())

      dispatch(eventAction.loadVenueList(id))
      dispatch(eventAction.loadCityVenueList(id))
      dispatch(eventAction.loadVenueLocations(id))
      dispatch(
        quotationAction.loadService({
          companyId,
          branchId,
          leadId,
          status,
        })
      )
      setTimeout(() => {
        // if (!isEmpty(segmentId)) {
        dispatch(quotationAction.loadQCLayoutSegment())
        // }
      }, 1500)
    }
  }, [eventAddDetails])

  useEffect(() => {
    if (deliverableAddDetails === true) {
      dispatch(quotationAction.loadDeliverableRecordsMetaData())
    }
  }, [deliverableAddDetails])

  const eventId = [serviceEventId]

  useEffect(() => {
    if (isEdit === true) {
      dispatch(
        quotationAction.loadService({
          companyId,
          branchId,
          leadId,
          eventId,
          status,
        })
      )
      dispatch(quotationAction.loadRecordsMetaData())

      dispatch(eventAction.loadVenueList(id))
      dispatch(eventAction.loadCityVenueList(id))
      dispatch(eventAction.loadVenueLocations(id))
    }
  }, [isEdit])

  const eventUpdate = useSelector((specificState) => specificState.Event)
  const followupUpdate = useSelector((specificState) => specificState.followup)
  const { city_venue = [], venue_locations = [] } = eventUpdate
  const { leadCarryForwardList = [] } = followupUpdate

  const leadCarryForwardListCheckList = get(
    leadCarryForwardList,
    "checkList",
    []
  )
  const leadCarryForwardListSpecialInstruction = get(
    leadCarryForwardList,
    "specialInstruction",
    []
  )

  const sessionUpdate = useSelector((specificState) => specificState.session)
  const { user = [] } = sessionUpdate

  ///Quotation Store and data table
  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const {
    record_quotation_details = [],
    quotationRecordsMetaData = {},
    instructionsMetaData = {},
    deliverablesMetaData = {},
    service_details = [],
    deliverable_details = [],
    checklist_details = [],
    instructions = [],
    service_total_account = [],
    quotationList = [],
    qc_history = [],
    qc_layout_master = [],
    qc_layout_segment = [],
  } = quotationUpdate
  const alterUpdate = useSelector((specificState) => specificState.alterQuote)
  const { alter_quote_history = [] } = alterUpdate

  //Qc sent process status

  const qcSentProcessStatus =
    !isEmpty(clientProfile) && clientProfile
      ? clientProfile[0].processStatus
      : []

  const salesManagerId = !isEmpty(user) && user.roleId

  // History modal
  const [historyForm, setHistoryForm] = useState(false)
  const handleHistoryClose = () => setHistoryForm(false)

  const salesManagerRoleId =
    !isEmpty(location) && location && location.id
      ? location.id.managerId
      : salesManagerId

  // Open modal for quotation event

  const [requestQc, setRequestQc] = useState(false)

  const managerView = salesManagerRoleId === "6320da65812dfec5383565f4"

  const eventBranchId =
    clientProfile &&
    clientProfile.leadDetails &&
    clientProfile.leadDetails[0].branchId

  const [quotationData, setQuotationData] = useState({
    leadId: id,
    branchId: eventBranchId,
    isLink: true,
    eventType: [],
    event: [],
    eventDate: "",
    crewAssemblyTime: "",
    startTime: "",
    endTime: "",
    venueLocation: [],
    venueName: "",
    crowdStrength: "",
    services: [],
  })

  //Deliverable Data
  const [deliverData, setDeliverData] = useState({
    leadId: id,
    eventId: "",
    deliverable: "",
    commercialMode: "",
    product: "",
    count: "",
    sheetLength: "",
    quantity: "",
    actualPrice: "",
    quotePrice: "",
    discount: "",
    upselling: "",
    deliveryMode: "",
    remarks: "",
    notes: "",
  })

  //Event form
  const [eventQuotationModal, setEventQuotationModal] = useState(false)
  const [deleteForm, setDeleteForm] = useState(false)
  const handleClose = () => setDeleteForm(false)

  //Event travel section
  const [travel, setTravel] = useState([])
  const [food, setFood] = useState([])

  const options = [
    {
      id: 1,
      label: "Client",
      value: "Client",
    },
    {
      id: 2,
      label: "Company",
      value: "Company",
    },
  ]
  //Deliverables form
  const [deliverModal, setDeliverModal] = useState(false)
  const [deleteDeliverForm, setDeleteDeliverForm] = useState(false)

  const [quotationRemoveId, setQuotationRemoveId] = useState("")
  const [deliverableRemoveId, setDeliverableRemoveId] = useState("")

  //Instructions and photography chekklist
  const [deleteInstructionsForm, setDeleteInstructionsForm] = useState(false)
  const [deleteChecklistForm, setDeleteChecklistForm] = useState(false)

  const handleDeliverClose = () => setDeleteDeliverForm(false)

  const handleInstructionsClose = () => setDeleteInstructionsForm(false)
  const handleChecklistClose = () => setDeleteChecklistForm(false)

  //Segment
  const [segmentByCategory, setSegmentByCategory] = useState([])

  const [segmentCheckBoxChecked, setSegmentCheckBoxChecked] = useState(false)
  const [segmentCheckBoxCheckedValue, setSegmentCheckBoxCheckedValue] =
    useState("")
  const [segmentCheckBoxDetail, setSegmentCheckBoxDetail] = useState("")

  //Preview checkbox
  const [previewChecked, setPreviewChecked] = useState("")
  const [previewShown, setPreviewShown] = useState("")
  const serviceTotal = service_total_account
  console.log(previewShown, "previewShown")

  useEffect(() => {
    if (previewChecked) {
      const quotationPreview = {
        leadId: id,
        isPreviewShown: previewChecked,
      }
      // if (isChecked) {
      specificDispatch(quotationAction.updateQuotationPreview(quotationPreview))
      toast.success("Preview show updated", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setTimeout(() => {
        dispatch(quotationAction.loadServiceTotal(id))
      }, 1000)
      // }
    }
  }, [previewChecked])

  //Preview check
  useEffect(() => {
    if (!isEmpty(serviceTotal)) {
      setPreviewShown(serviceTotal.isPreviewShown)
    }
  }, [serviceTotal])

  //Discount checkbox
  const [discountChecked, setDiscountChecked] = useState("")
  const [discountCheckedModal, setDiscountCheckedModal] = useState(false)
  const handleDiscountChecked = () => setDiscountCheckedModal(false)

  useEffect(() => {
    if (discountChecked === true) {
      setDiscountCheckedModal(true)
    } else if (discountChecked === false) {
      setDiscountCheckedModal(true)
    }
  }, [discountChecked])

  const handleDiscountDetails = () => {
    const discountPreview = {
      leadId: id,
      isDiscountPreview: discountChecked,
    }

    specificDispatch(quotationAction.updateDiscountPreview(discountPreview))

    setTimeout(() => {
      specificDispatch(quotationAction.loadServiceTotal(id))
      if (discountChecked === true) {
        toast.success("Discount Preview Checked Successfully")
      } else if (discountChecked === false) {
        toast.success("Discount Preview Unchecked Successfully")
      }
      setDiscountCheckedModal(false)
    }, 1000)
  }

  //Quotation Final submit
  const [quotationForm, setQuotationForm] = useState(false)

  const handleQuotationClose = () => setQuotationForm(false)
  const [quotationUpdateForm, setQuotationUpdateForm] = useState(false)

  const handleQuotationUpdateClose = () => setQuotationUpdateForm(false)

  /// api list details from reducer
  const [openPreviewModal, setOpenPreviewModal] = useState(false)
  const [openPreviewSubmitModal, setOpenPreviewSubmitModal] = useState(false)
  const [activeTab, setActiveTab] = useState("")

  const segmentDetails =
    !isEmpty(qc_layout_segment) && qc_layout_segment.length > 0
      ? qc_layout_segment.map((data) => {
          if (segmentId === data._id) {
            return data && data.layoutLink
          }
        })
      : []

  const segmentIdDetails =
    !isEmpty(segmentDetails) &&
    segmentDetails.filter((data) => data !== undefined)

  const historyDetails = !isEmpty(qc_history) && qc_history.reviseList
  const alterHistoryDetails =
    !isEmpty(alter_quote_history) && alter_quote_history

  const commercialMode = [
    {
      id: 1,
      label: "FREE",
      value: "FREE",
    },
    {
      id: 2,
      label: "PAID",
      value: "PAID",
    },
  ]

  //Dropdown list value

  const [eventType, setEventType] = useState([])
  const [event, setEvent] = useState([])
  const [venueLocation, setVenueLocation] = useState([])

  const [renderPage, setRenderPage] = useState(false)
  const [updateInstruction, setUpdateInstruction] = useState(false)
  const [updateChecklist, setUpdateChecklist] = useState(false)

  const [serviceDetailData, setServiceDetailData] = useState([])
  const [serviceDetailDataSet, setServiceDetailDataSet] = useState(false)
  const [oddServiceData, setOddServiceData] = useState([])
  const [evenServiceData, setEvenServiceData] = useState([])

  const [premium, setPremium] = useState(false)
  const [cityVenueName, setCityVenueName] = useState([])
  const [updateVenue, setUpdateVenue] = useState(false)
  const [expiry, setExpiry] = useState({
    expiryDate: "",
  })

  //Venue name options and funtionality
  const venueLocationsList =
    !isEmpty(venue_locations) && venue_locations.length > 0
      ? venue_locations.map((venue) => {
          const venueLocation = venue.name.toUpperCase()
          if (venue.status === 1) {
            return {
              _id: venue._id,
              name: venueLocation,
            }
          } else {
            return {
              _id: "",
            }
          }
        })
      : []

  const createVenueLocationOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.name
        options.push(obj)
      })
    return options
  }

  const venueLocationOptions = createVenueLocationOptions(venueLocationsList)

  const [venueLocationAdded, setVenueLocationAdded] = useState(false)
  var lastArrayCityId = venueLocationAdded
    ? venue_locations[venue_locations.length - 1]._id
    : []

  useEffect(() => {
    if (venueLocationAdded === true) {
      setVenueLocation({ label: newVenueLocation, value: lastArrayCityId })
      setQuotationData({
        ...quotationData,
        venueLocation: [{ label: newVenueLocation, value: lastArrayCityId }],
      })
    }
  }, [venue_locations])

  //Change venue Location
  const handleVenueLocations = (e) => {
    setVenueLocation(e)
    setCityVenueName([])
    setPremium(false)
  }

  const handleVenueTab = () => {
    setVenueLocationAdd(!venueLocationAdd)
    setCityVenueName([])
    setVenueLocation([])
    setNewVenueLocation("")
    setPremium(false)
  }

  const handleVenueNameTab = () => {
    setVenueAdd(!venueAdd)
    setCityVenueName([])
    setNewVenue("")
    setPremium(false)
  }

  //Venue Name functionality

  //Venue name options and funtionality
  const venueList =
    !isEmpty(city_venue) && city_venue.length > 0
      ? city_venue.map((venue) => {
          const venueName = venue.venueName.toUpperCase()
          if (venue.status === 1) {
            return {
              cityId: venue.cityId,
              venueName: venueName,
              isPremium: venue.isPremium,
              _id: venue._id,
              status: venue.status,
            }
          } else {
            return {
              _id: "",
            }
          }
        })
      : []
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.venueName
        obj.isPremium = element.isPremium
        obj.cityId = element.cityId
        options.push(obj)
      })
    return options
  }

  const venueOptions = createOptions(venueList)

  const cityVenueOptions =
    !isEmpty(venueOptions) &&
    venueOptions.filter((city) => {
      return city.cityId === venueLocation.value
    })

  const [venueNameAdded, setVenueNameAdded] = useState(false)

  useEffect(() => {
    if (venueNameAdded === true) {
      setCityVenueName({ label: newVenue, value: "" })
      setQuotationData({
        ...quotationData,
        venueName: [{ label: newVenue, value: "" }],
      })
    }
  }, [city_venue])

  //Service Input changes

  const changeOddService = async (e, index, id, name) => {
    var servicesList = serviceDetailData

    e = e.target.value
    console.log(index)

    servicesList
      .filter((someobject) => someobject._id == id)

      .forEach((someobject) => {
        someobject[name] = e
        if (name == "quantity" && e > 0) {
          someobject["quantity"] = e
          someobject["amount"] = someobject["actualAmount"]
        } else if (name == "quantity" && e == 0) {
          someobject["amount"] = ""
        }
      })
    // setOddServiceData([...oddServiceData])
    setServiceDetailData(servicesList)
    setRenderPage(!renderPage)
  }
  const changeEvenService = async (e, index, id, name) => {
    var servicesList = serviceDetailData
    console.log(index)
    e = e.target.value
    servicesList
      .filter((someobject) => someobject._id == id)

      .forEach((someobject) => {
        someobject[name] = e
        if (name == "quantity" && e > 0) {
          someobject["quantity"] = e
          someobject["amount"] = someobject["actualAmount"]
        } else if (name == "quantity" && e == 0) {
          someobject["amount"] = ""
        }
      })
    // setEvenServiceData([...evenServiceData])
    setServiceDetailData(servicesList)
    setRenderPage(!renderPage)
  }

  const handleChange = (e) => {
    setQuotationData({ ...quotationData, [e.target.name]: e.target.value })
  }

  //Validator
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const [, forceDeliverUpdate] = useState()

  const quotationTableDetails = record_quotation_details

  // Service api list
  const serviceDetails = !isEmpty(service_details)
    ? service_details.map((service) => {
        return {
          _id: service._id,
          companyId: service.companyId,
          branchId: service.branchId,
          eventId: service.eventId,
          serviceName: service.serviceName,
          amount: "",
          quantity: "",
          status: service.status,
          actualAmount: service.amount,
        }
        // }
      })
    : []

  if (serviceDetails && serviceDetails.length > 0 && !serviceDetailDataSet) {
    setServiceDetailData(serviceDetails)
    setServiceDetailDataSet(true)

    var array = serviceDetails
    var evenServiceArray = []
    var oddServiceArray = []

    for (var i = 0; i < array.length; i++) {
      if (i % 2 == 0) {
        oddServiceArray.push(array[i])
      } else {
        evenServiceArray.push(array[i])
      }
    }
    setOddServiceData(oddServiceArray)
    setEvenServiceData(evenServiceArray)
  }

  //Event Data Table section
  const eventDataTable = !isEmpty(quotationTableDetails)
    ? quotationTableDetails.map((events, index) => {
        return {
          _id: events.leadEventId,
          leadQuotationEventId: events.leadQuotationEventId,
          sNo: index + 1,
          status: 1,
          eventName: events.eventName,
          event: events.event,
          food: events.food,
          travelStay: events.travelStay,
          eventNo: events.eventNo,
          startTime: events.startTime,
          endTime: events.endTime,
          eventType: events.eventType,
          eventTypeName: events.eventTypeName,
          eventDate:
            !isEmpty(events.eventDate) || events.eventData != null
              ? moment(events.eventDate).format("YYYY-MM-DD")
              : "--",
          crewAssemblyTime: events.crewAssemblyTime,
          venueLocation: events.venueLocation,
          venueName: events.venueName,
          venueId: events.venueId,
          crowdStrength: events.crowdStrength,
          upselling: events.totalUpselling,
          value: !isEmpty(events.totalValue) ? events.totalValue : 0,
          discount: !isEmpty(events.totalDiscount) ? events.totalDiscount : 0,
          amount: !isEmpty(events.totalAmount) ? events.totalAmount : 0,
          services: !isEmpty(events.service) ? events.service : 0,
          isMainEvent: events.isMainEvent,
        }
      })
    : []

  /// Event details form actions
  //Form submission
  const handleSubmit = () => {
    window.scrollTo(0, 1000)
    if (simpleValidator.current.allValid()) {
      const serviceSubmit = !isEmpty(serviceDetailData)
        ? serviceDetailData.map((service) => {
            if (service.quantity || service.amount) {
              return {
                serviceId: service._id ? service._id : "",
                quantity: service.quantity ? parseFloat(service.quantity) : "",
                actualAmount: service.actualAmount
                  ? parseFloat(service.actualAmount)
                  : "",
                amount: service.amount ? parseFloat(service.amount) : "",
              }
            }
          })
        : []

      const quotationUpdate = {
        leadId: quotationData.leadId,
        leadEventId: eventDataTable._id,
        isLink: true,
        branchId: eventBranchId,
        eventType: eventType.value,
        event: event.value,
        eventDate: quotationData.eventDate,
        crewAssemblyTime: quotationData.crewAssemblyTime,
        startTime: quotationData.startTime,
        endTime: quotationData.endTime,
        venueLocation: venueLocation.label,
        venueName: cityVenueName.label,
        venueId: cityVenueName.value,
        travelStay: travel.value,
        food: food.value,
        isMainEvent: isMainEvent,
        crowdStrength: parseFloat(quotationData.crowdStrength),
        services: serviceSubmit.filter(function (item) {
          return item != null
        }),
      }
      specificDispatch(quotationAction.createQuotationRecord(quotationUpdate))
      setTimeout(() => {
        specificDispatch(quotationAction.loadRecordQuotationDetails(id))
        specificDispatch(quotationAction.loadServiceTotal(id))
        setPageload(true)
        toast.success("Event Details Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setEventQuotationModal(true)

      return false
    }
  }
  const [venueId, setVenueId] = useState("")
  console.log(serviceDetails, "serviceDetails")
  console.log(serviceDetailData, "serviceDetailData")
  // Edit screen
  const editEventDetails = (events) => {
    window.scrollTo(0, 1200)

    console.log(events.services, "edit details data 1")
    var eventServiceData = events.services
    serviceDetailData.map((service) => {
      service.quantity = ""
      service.amount = ""
    })
    var serviceData = serviceDetailData
    eventServiceData &&
      eventServiceData.map((service) => {
        serviceData
          .filter((someobject) => someobject._id === service.serviceId)
          .forEach((someobject) => {
            someobject["quantity"] = service.quantity
            someobject["amount"] = service.amount
          })
      })
    setServiceDetailData([...serviceData])
    console.log(serviceData, "edit details data 2")
    console.log(serviceDetailData, "edit details data 3")
    var array = serviceData
    var evenServiceArray = []
    var oddServiceArray = []
    for (var i = 0; i < array.length; i++) {
      if (i % 2 == 0) {
        oddServiceArray.push(array[i])
      } else {
        evenServiceArray.push(array[i])
      }
    }
    setOddServiceData(oddServiceArray)
    setEvenServiceData(evenServiceArray)
    // setEventAddDetails(true)

    setEvent({ value: events.event, label: events.eventName })
    setFood({ value: events.food, label: events.food })
    setTravel({ value: events.travelStay, label: events.travelStay })
    setEventType({ label: events.eventTypeName, value: events.eventType })
    setVenueLocation({ value: "", label: events.venueLocation })
    setCityVenueName({ value: events.venueId, label: events.venueName })
    setIsMainEvent(events.isMainEvent)
    setQuotationData({
      ...quotationData,
      leadId: quotationData.leadId,
      _id: events._id,
      leadQuotation: events.leadQuotationEventId,
      isLink: true,
      branchId: eventBranchId,
      eventType: [{ label: events.eventTypeName, value: events.eventType }],
      event: [{ label: events.eventName, value: events.event }],
      eventDate: events.eventDate,
      crewAssemblyTime: events.crewAssemblyTime,
      startTime: events.startTime,
      endTime: events.endTime,
      venueLocation: [{ value: "", label: events.venueLocation }],
      venueName: [{ value: "", label: events.venueName }],
      crowdStrength: parseFloat(events.crowdStrength),
      services: events.services,
    })
    setIsEdit(true)
    setEventQuotationModal(true)
    setUpdateVenue(true)
    setVenueId(events.venueId)

    setServiceEventId(events.event)
  }

  const qCLayoutMasterChange = (value) => {
    const segmentFilterData =
      qc_layout_segment &&
      qc_layout_segment.filter((data) => data.layoutMasterId == value)

    const segmentData = !isEmpty(segmentFilterData)
      ? segmentFilterData.map((data, index) => {
          return {
            key: index,
            id: get(data, "_id", ""),
            segmentName: get(data, "segmentName", ""),
            layoutLink: get(data, "layoutLink", ""),
          }
        })
      : []
    setSegmentByCategory(segmentData)
  }

  const qCLayoutSegmentChange = (value) => {
    setSegmentCheckBoxCheckedValue(value.id)
    setSegmentCheckBoxDetail(value)
    setSegmentCheckBoxChecked(!segmentCheckBoxChecked)
  }

  useEffect(() => {
    quotationData
  }, [quotationData])

  useEffect(() => {
    if (
      isQuotation === true ||
      (isQuotation === false && qcSentProcessStatus === "PS17") ||
      qcSentProcessStatus === "PS7"
    ) {
      dispatch(quotationAction.loadQcHistory(id))
      dispatch(alterAction.loadAlterQuoteHistory(id))
    }
  }, [])

  //Update
  const handleUpdate = (record, success) => {
    window.scrollTo(0, 800)
    const leadEvent = quotationData._id
    const leadQuotationEvent = quotationData.leadQuotation

    const serviceSubmit = !isEmpty(serviceDetailData)
      ? serviceDetailData.map((service) => {
          if (service.quantity || service.amount) {
            return {
              serviceId: service._id ? service._id : "",
              quantity: service.quantity ? parseFloat(service.quantity) : "",
              actualAmount: service.actualAmount
                ? parseFloat(service.actualAmount)
                : "",
              amount: service.amount ? parseFloat(service.amount) : "",
            }
          }
        })
      : []
    const quotationUpdate = {
      leadId: quotationData.leadId,
      leadEventId: leadEvent,
      leadQuotationEventId: leadQuotationEvent,
      isLink: true,
      branchId: quotationData.branchId,
      eventType: eventType.value,
      event: event.value,
      eventDate: quotationData.eventDate,
      crewAssemblyTime: quotationData.crewAssemblyTime,
      startTime: quotationData.startTime,
      endTime: quotationData.endTime,
      venueLocation: venueLocation.label,
      venueName: cityVenueName.label,
      venueId: cityVenueName.value,
      travelStay: travel.value,
      food: food.value,
      isMainEvent: isMainEvent,
      crowdStrength: quotationData.crowdStrength,
      services: serviceSubmit.filter(function (item) {
        return item != null
      }),
    }
    specificDispatch(
      quotationAction.updateQuotationRecord(quotationUpdate, record, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadRecordQuotationDetails(id))
      specificDispatch(quotationAction.loadServiceTotal(id))
      setPageload(true)

      toast.success("Records Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
    setIsEdit(false)
  }

  //Add venue details
  const addVenueDetails = () => {
    const venueData = {
      venueName: newVenue.toUpperCase(),
      isPremium: premium,
      cityId: venueLocation.value,
    }
    specificDispatch(eventAction.addVenueList(venueData))
    setVenueAdd(false)
    setAddedVenue(true)
    setTimeout(() => {
      specificDispatch(eventAction.loadCityVenueList(id))
      setAddedVenue(false)
    }, 2000)
  }

  //Update venue details
  const updateVenueDetails = () => {
    const venueData = {
      _id: venueId,
      cityId: venueLocation.value,
      venueName: "Kg mahal",
      isPremium: premium,
    }
    specificDispatch(eventAction.updateVenueList(venueData))
    // setTimeout(() => {
    specificDispatch(eventAction.loadVenueList())
    // }, 2000)
  }

  //Add venue Location details
  const addVenueLocationDetails = () => {
    const locationData = {
      name: newVenueLocation.toUpperCase(),
    }
    specificDispatch(eventAction.addVenueLocations(locationData))
    setVenueLocationAdd(false)
    setAddedVenueLocation(true)
    setTimeout(() => {
      specificDispatch(eventAction.loadVenueLocations(id))
      setAddedVenueLocation(false)
    }, 2000)
  }

  //Update venue details
  const updateVenueLocationDetails = () => {
    const locationData = {
      _id: id,
      name: newVenueLocation,
    }
    specificDispatch(eventAction.updateVenueLocations(locationData))
    setTimeout(() => {
      specificDispatch(eventAction.loadVenueLocations(id))
    }, 2000)
  }

  //Delete
  const removeEventDetails = (success) => {
    const quotationLeadId = quotationData.leadId

    specificDispatch(
      quotationAction.deleteQuotationRecord(
        quotationLeadId,
        quotationRemoveId,
        success
      )
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadRecordQuotationDetails(id))
      specificDispatch(quotationAction.loadServiceTotal(id))
      setPageload(true)
      toast.success("Event details deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const handleAddEvent = () => {
    window.scrollTo(0, 1000)
    // document.getElementById("quoteEvent").scrollIntoView()
    setEventQuotationModal(true)
    setQuotationData({
      leadId: id,
      branchId: eventBranchId,
      isLink: true,
      eventType: [],
      event: [],
      eventDate: "",
      crewAssemblyTime: "",
      startTime: "",
      endTime: "",
      venueLocation: [],
      venueName: "",
      crowdStrength: "",
    })
    setIsMainEvent(false)
    setEventType([])
    setEvent([])
    setVenueLocation([])
    setCityVenueName([])
    setFood([])
    setTravel([])
    setIsEdit(false)
    setEventAddDetails(true)
    serviceDetailData.map((service) => {
      service.quantity = ""
      service.amount = ""
    })
    var serviceData = serviceDetailData
    serviceDetailData &&
      serviceDetailData.map((service) => {
        serviceData
          .filter((someobject) => someobject._id == service.serviceId)
          .forEach((someobject) => {
            someobject["quantity"] = ""
            someobject["amount"] = ""
          })
      })
    setServiceDetailData([...serviceData])
    var array = serviceData
    var evenServiceArray = []
    var oddServiceArray = []
    for (var i = 0; i < array.length; i++) {
      if (i % 2 == 0) {
        oddServiceArray.push(array[i])
      } else {
        evenServiceArray.push(array[i])
      }
    }
    setOddServiceData(oddServiceArray)
    setEvenServiceData(evenServiceArray)

    // const serviceDetails = !isEmpty(service_details)
    //   ? service_details.map((service) => {
    //       return {
    //         _id: service._id,
    //         companyId: [service.companyId],
    //         branchId: [service.branchId],
    //         eventId: [service.eventId],
    //         serviceName: service.serviceName,
    //         amount: "",
    //         quantity: "",
    //         status: service.status,
    //         actualAmount: service.amount,
    //       }
    //     })
    //   : []
  }

  //Button components functionality

  // Open modal for request Qc

  const [requestModal, setRequestModal] = useState(false)
  const handleRequestClose = () => setRequestModal(false)

  const [alterHistoryForm, setAlterHistoryForm] = useState(false)
  const handleAlterRequestClose = () => setAlterHistoryForm(false)

  // Open modal for quotation event

  const [requestView, setRequestView] = useState(false)

  const [requestDeliverView, setRequestDeliverView] = useState(false)

  //ApprovalQc request

  var leadQuotationId = !isEmpty(serviceTotal) && serviceTotal.leadQuotationId

  const handleApproval = (success) => {
    var leadId = id
    specificDispatch(
      quotationAction.approvalRequestQc(leadId, leadQuotationId, success)
    )
    setTimeout(() => {
      toast.success("QC approval successfully accepted", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      handleRequestClose()
      setRequestQc(true)
      specificDispatch(
        clientAction.loadRecordClientProfileById({ clientId: leadClientId })
      )
    }, 2000)
  }

  const [quotationLoading, setQuotationLoading] = useState(false)

  //QC approve functionality start

  var quotationDate =
    !isEmpty(serviceTotal) &&
    moment(serviceTotal.leadQuotationDate).format("DD-MM-YYYY hh:mm A")
  var quotationNumber =
    !isEmpty(serviceTotal) && serviceTotal.leadQuotationNumber

  var reviseCount =
    !isEmpty(qc_history) && qc_history.reviseCount ? qc_history.reviseCount : ""

  /// Deliverables details form actions
  const handleDeliverChange = (e) => {
    setDeliverData({ ...deliverData, [e.target.name]: e.target.value })
  }

  //Deliverable state values

  const [product, setProduct] = useState([])
  const [subproduct, setSubProduct] = useState([])
  const [commercial, setCommercial] = useState([])
  const [deliveryMode, setDeliveryMode] = useState([])
  const [deliverEvent, setDeliverEvent] = useState([])
  const [deliverable, setDeliverable] = useState([])
  const [checked, setChecked] = useState(false)

  const productOptions =
    !isEmpty(deliverablesMetaData) &&
    deliverablesMetaData.productOptions.filter(
      (product) => product.deliverable === deliverable.value
    )

  const subProductOptions =
    !isEmpty(deliverablesMetaData) &&
    deliverablesMetaData.subProductOptions.filter(
      (subProduct) => subProduct.value === product.subProductId
    )

  const changeDeliverable = (e) => {
    setDeliverable(e)

    var dataDeliver = deliverData
    dataDeliver.count = e ? "" : deliverData.count
    dataDeliver.actualPrice = e ? "" : deliverData.actualPrice
    dataDeliver.quantity = e ? "" : deliverData.quantity
    dataDeliver.quotePrice = e ? "" : deliverData.quotePrice

    dataDeliver.sheetLength =
      e && e.sheet && e.sheet != "undefined"
        ? ""
        : e && e.length && e.length != "undefined"
        ? ""
        : ""
    setProduct([])
    setSubProduct([])
    setDeliverData(dataDeliver)
  }

  const changeProduct = (e, product) => {
    console.log(product)
    setProduct(e)
    var dataDeliver = deliverData

    if (commercial.label === "FREE") {
      dataDeliver.count = 0
      dataDeliver.actualPrice = 0
      dataDeliver.quotePrice = 0
      dataDeliver.quantity = 0
      dataDeliver.sheetLength = 0

      setDeliverData(dataDeliver)
      setChecked(true)
    } else {
      dataDeliver.count = e && e.count && e.count != "undefined" ? e.count : 0
      dataDeliver.actualPrice = e && e.price ? e.price : deliverData.actualPrice
      dataDeliver.quotePrice = e && e.price ? e.price : deliverData.quotePrice
      dataDeliver.quantity =
        e && e.productQuantity ? e.productQuantity : deliverData.quantity
      dataDeliver.sheetLength =
        e && e.sheet && e.sheet !== "undefined"
          ? e.sheet
          : e && e.length && e.length !== "undefined"
          ? e.length
          : 0

      setDeliverData(dataDeliver)
      setChecked(true)
    }
  }

  const changeCommercialMode = (e) => {
    setCommercial(e)

    var dataDeliver = deliverData
    dataDeliver.count = e && e.label === "FREE" ? 0 : deliverData.count
    dataDeliver.actualPrice =
      e && e.label === "FREE" ? 0 : deliverData.actualPrice
    dataDeliver.quotePrice =
      e && e.label === "FREE" ? 0 : deliverData.quotePrice
    dataDeliver.quantity = e && e.label === "FREE" ? 0 : deliverData.quantity

    dataDeliver.sheetLength =
      e && e.label === "FREE" ? 0 : deliverData.sheetLength

    setDeliveryMode([])
    setProduct([])

    setDeliverData(dataDeliver)
  }

  const handleAddDeliverable = () => {
    window.scrollTo(0, 1500)
    setDeliverableAddDetails(true)
    setCommercial({
      label: commercialMode[1].label,
      value: commercialMode[1].value,
    })
    setDeliverModal(true)
    setDeliverData({
      leadId: id,
      eventId: "",
      deliverable: "",
      commercialMode: [
        { label: commercialMode[1].label, value: commercialMode[1].value },
      ],
      product: "",
      count: "",
      sheetLength: "",
      quantity: "",
      actualPrice: "",
      quotePrice: "",
      discount: "",
      upselling: "",
      deliveryMode: "",
      remarks: "",
      notes: "",
    })
    setProduct([])
    setDeliverable([])
    // setCommercial([])
    setDeliverEvent([])
    setSubProduct([])
    setDeliveryMode([])
    setIsEdit(false)
  }

  const eventNoOptions =
    !isEmpty(record_quotation_details) &&
    record_quotation_details.map((events) => {
      return {
        id: events.leadEventId,
        eventNo: events.eventNo,
        eventName: events.eventName,
      }
    })

  const createEventOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element.id
        obj.label = element.eventNo
        obj.eventName = element.eventName
        options.push(obj)
      })
    return options
  }

  const eventDeliverableOptions = createEventOptions(eventNoOptions)

  //Form submission
  const handleDeliverSubmit = () => {
    //  if(e.target.value === deliverData.quantity)
    window.scrollTo(0, 1300)
    // e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const deliverEventDetails =
        deliverEvent && deliverEvent.length > 0
          ? deliverEvent.map((deliver) => {
              return deliver.value
            })
          : []
      const deliverUpdate = {
        leadId: deliverData.leadId,
        eventId: deliverEventDetails.filter((data) => {
          return data != null
        }),
        // deliverable: deliverable.label,
        deliverableId: deliverable.value,
        deliverableType: deliverable.label,
        commercialMode: commercial.value,
        productId: product.value,
        count: parseFloat(deliverData.count),
        sheetLength: deliverData.sheetLength,
        quantity: parseFloat(deliverData.quantity),
        // discount: parseFloat(deliverData.discount),
        actualPrice: parseFloat(deliverData.actualPrice),
        quotePrice: parseFloat(deliverData.quotePrice),
        // upselling: parseFloat(deliverData.upselling),
        deliveryModeId: deliveryMode.value,
        remarks: deliverData.remarks,
        notes: deliverData.notes,
      }
      specificDispatch(quotationAction.createDeliverable(deliverUpdate))

      setTimeout(() => {
        specificDispatch(quotationAction.loadDeliverableDetails(id))
        specificDispatch(quotationAction.loadServiceTotal(id))

        // setPageload(true)
        toast.success("Deliverable Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
      setDeliverModal(false)
    } else {
      simpleValidator.current.showMessages()
      forceDeliverUpdate(1)
      setDeliverModal(true)
      return false
    }
  }

  const deliverableData = deliverable_details

  //Deliverable Data Table section
  const deliverDataTable = !isEmpty(deliverableData)
    ? deliverableData.map((deliver, index) => {
        const deliverId = get(deliver, "_id", "")
        const deliverStatus = get(deliver, "status", "")
        const deliverQuantity = get(deliver, "quantity", "No quantity")
        const deliverActualPrice = get(deliver, "actualPrice", "No actualPrice")
        const deliverQuotePrice = get(deliver, "quotePrice", "No quotePrice")
        // const deliverDiscount = get(deliver, "discount", "No discount")
        const deliverUpselling = get(deliver, "upselling", "No upselling")
        const deliverFinalAmount = get(deliver, "finalAmount", "No price")
        const deliverableType = get(
          deliver,
          "deliverableName",
          "No deliverableType"
        )
        const deliverProduct = get(deliver, "productName", "No product Name")
        const deliverCommercial = get(deliver, "commercialMode", "No price")
        const deliveryMode = get(deliver, "deliveryModeName", "No deliver")

        return {
          _id: deliverId,
          sNo: index + 1,
          status: deliverStatus,
          eventNo:
            !isEmpty(deliver) && deliver.eventNo && deliver.eventNo.length > 0
              ? deliver.eventNo.join(" , ")
              : deliver.eventNo,
          eventName:
            !isEmpty(deliver) && deliver.eventName ? deliver.eventName : [],
          eventId:
            !isEmpty(deliver) && deliver.eventId && deliver.eventId.length > 0
              ? deliver.eventId.join(" , ")
              : deliver.eventId,
          deliverableType: deliverableType,
          deliverableId: deliver.deliverableId,
          productId: deliver.productId,
          productName: deliverProduct,
          commercialMode: deliverCommercial,
          quantity: deliverQuantity,
          actualPrice: deliverActualPrice,
          quotePrice: deliverQuotePrice,
          discount: deliver.discount,
          count: deliver.count,
          sheet: deliver.sheetLength,
          length: deliver.length,
          finalAmount: deliverFinalAmount,
          upselling: deliverUpselling,
          deliveryModeName: deliveryMode,
          deliveryModeId: deliver.deliveryModeId,
        }
      })
    : []

  // Edit screen
  const editDeliverDetails = (deliver) => {
    window.scrollTo(0, 1500)
    setDeliverableAddDetails(true)

    var eventIdString = ""
    var eventNoString = ""

    if (deliver.eventId) {
      eventIdString = deliver.eventId.split(",")
    }
    if (deliver.eventNo) {
      eventNoString = deliver.eventNo.split(",")
    }
    let eventNoVal = []
    if (
      eventIdString &&
      eventIdString.length > 0 &&
      eventNoString &&
      eventNoString.length > 0
    ) {
      for (let i = 0; i < eventNoString.length; i++) {
        eventNoVal.push({ label: eventNoString[i], value: eventIdString[i] })
      }
    }
    setDeliverEvent(eventNoVal)
    setDeliverable({
      label: deliver.deliverableType,
      value: deliver.deliverableId,
    })
    setCommercial({
      label: deliver.commercialMode,
      value: "",
    })
    setProduct({
      label: deliver.productName,
      value: deliver.productId,
      count: deliver.count,
      sheet: deliver.sheet,
      productQuantity: deliver.quantity,
      price: deliver.quotePrice,
    })
    setDeliveryMode({
      label: deliver.deliveryModeName,
      value: deliver.deliveryModeId,
    })
    const countDetail = deliver.count === null ? 0 : deliver.count
    const sheetDetail = deliver.sheet === null ? 0 : deliver.sheet

    setDeliverData({
      ...deliverData,
      leadId: id,
      leadQuotationDeliverable: deliver._id,
      eventId: [{ label: deliver.eventNo, value: deliver.eventId }],
      deliverableId: [{ label: "", value: deliver.deliverableId }],
      deliverableType: [{ label: deliver.deliverableType, value: "" }],
      commercialMode: [{ label: deliver.commercialMode, value: "" }],
      product: [{ label: "", value: deliver.productId }],
      productName: [{ label: deliver.productName, value: "" }],
      count: countDetail,
      sheetLength: sheetDetail,
      quantity: deliver.quantity,
      actualPrice: deliver.actualPrice,
      quotePrice: deliver.finalAmount,
      discount: deliver.discount,
      upselling: deliver.upselling,
      deliveryMode: [
        { label: deliver.deliveryModeName, value: deliver.deliveryModeId },
      ],
      remarks: deliver.remarks,
    })
    setIsEdit(true)
    setDeliverModal(true)
  }

  useEffect(() => {
    deliverData
  }, [deliverData])

  //Update
  const handleDeliverUpdate = (record, success) => {
    window.scrollTo(0, 1300)

    const deliverEventDetails =
      deliverEvent &&
      deliverEvent.length > 0 &&
      deliverEvent.map((deliver) => {
        let valueType = typeof deliver.value
        if (deliver.value && valueType === "object") {
          return deliver.value[0].trim()
        } else {
          return deliver.value.trim()
        }
      })

    const deliverUpdate = {
      leadId: id,
      eventId: deliverEventDetails && deliverEventDetails,
      leadQuotationDeliverableId: deliverData.leadQuotationDeliverable,
      deliverableId: deliverable.value,
      deliverableType: deliverable.label,
      commercialMode: commercial.label,
      productId: product.value,
      count: deliverData.count,
      sheetLength: deliverData.sheetLength,
      quantity: parseFloat(deliverData.quantity),
      discount: parseFloat(deliverData.discount),
      actualPrice: parseFloat(deliverData.actualPrice),
      quotePrice: parseFloat(deliverData.quotePrice),
      upselling: parseFloat(deliverData.upselling),
      deliveryModeId: deliveryMode.value,
      remarks: deliverData.remarks,
    }
    specificDispatch(
      quotationAction.updateDeliverable(deliverUpdate, record, success)
    )

    setTimeout(() => {
      specificDispatch(quotationAction.loadDeliverableDetails(id))
      specificDispatch(quotationAction.loadServiceTotal(id))
      toast.success("Records Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      // setPageload(true)
      setDeliverModal(false)
      setIsEdit(false)
    }, 1000)
  }

  //Delete
  const removeDeliverDetails = (success) => {
    const deliverLeadId = id

    specificDispatch(
      quotationAction.deleteDeliverable(
        deliverLeadId,
        deliverableRemoveId,
        success
      )
    )

    setTimeout(() => {
      specificDispatch(quotationAction.loadDeliverableDetails(id))
      specificDispatch(quotationAction.loadServiceTotal(id))

      setPageload(true)
      toast.success("Deliver details deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  // Value Insert

  const [updateValueInsert, setUpdateValueInsert] = useState(false)

  const [insertList, setInsertList] = useState({
    insertAmount: "",
    insertPercentage: "",
  })
  const valueInsertChange = (e) => {
    setInsertList({
      ...insertList,
      [e.target.name]: e.target.value,
    })
  }

  const handleValueInsert = (success) => {
    const valueInsert = {
      leadId: id,
      insertedAmount: insertList.insertAmount,
      insertedPercentage: 0,
    }
    specificDispatch(quotationAction.createValueInsert(valueInsert, success))
    setTimeout(() => {
      specificDispatch(quotationAction.loadServiceTotal(id))
      setUpdateValueInsert(false)
    }, 2000)
  }

  const editValueInsertDetails = (item) => {
    setInsertList({
      ...insertList,
      leadId: id,
      insertAmount: item.insertedAmount,
      insertPercentage: item.insertedPercentage,
    })
    setUpdateValueInsert(true)
  }

  //Update Value insert
  const updateValueInsertDetails = (record, success) => {
    const valueInsert = {
      leadId: id,
      insertedAmount: insertList.insertAmount,
      insertedPercentage: insertList.insertPercentage,
    }

    specificDispatch(
      quotationAction.updateValueInsert(valueInsert, record, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadServiceTotal(id))
      setUpdateValueInsert(false)
    }, 2000)
  }

  const [valueDeleteInsertForm, setValueDeleteInsertForm] = useState(false)
  const handleValueInsertClose = () => setValueDeleteInsertForm(false)
  //Delete Value insert
  const deleteValueInsertDetails = (record, success) => {
    const valueInsert = {
      leadId: id,
      insertedAmount: 0,
      insertedPercentage: 0,
    }

    specificDispatch(
      quotationAction.deleteValueInsert(valueInsert, record, success)
    )

    setTimeout(() => {
      specificDispatch(quotationAction.loadServiceTotal(id))
      setUpdateValueInsert(true)
      setInsertList({
        insertAmount: "",
        insertPercentage: "",
      })
    }, 2000)
  }

  //Special Instructions
  const [specialInstructionSet, setSpecialInstructionSet] = useState(false)
  const [instructionsList, setInstructionsList] = useState({
    departmentId: "",
    teamId: "",
    remarks: "",
  })

  const instructionsChange = (e) => {
    setInstructionsList({
      ...instructionsList,
      [e.target.name]: e.target.value,
    })
  }

  const [department, setDepartment] = useState([])
  const [team, setTeam] = useState([])
  const [instructionsAdd, setInstructionsAdd] = useState(false)

  const addSpecialInstruction = () => {
    setInstructionsList({
      departmentId: "",
      teamId: "",
      remarks: "",
    })
    setInstructionsAdd(true)
    setDepartment([])
    setTeam([])
    setSpecialInstructionSet(true)
    setRenderPage(true)
  }

  const handleInstructions = (success) => {
    const instructionUpdate = {
      leadId: id,
      specialInstruction: [
        {
          departmentId: department.value,
          teamId: team.value,
          remarks: instructionsList.remarks,
        },
      ],
    }
    specificDispatch(
      quotationAction.createInstruction(instructionUpdate, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadInstructions(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      setSpecialInstructionSet(false)
    }, 2000)
  }

  const editInstructions = (item) => {
    setDepartment({ label: item.departmentName, value: item.departmentId })
    setTeam({ label: item.teamName, value: item.teamId })

    setInstructionsList({
      ...instructionsList,
      leadId: id,
      specialInstructionsId: item._id,
      departmentId: [{ value: item.departmentId }],
      departmentName: [{ label: item.departmentName }],
      teamId: [{ value: item.teamId }],
      teamName: [{ label: item.teamName }],
      remarks: item.remarks,
    })
    setInstructionsAdd(true)
    setUpdateInstruction(true)
    setSpecialInstructionSet(true)
  }

  useEffect(() => {
    if (instructionsAdd == true) {
      dispatch(quotationAction.loadInstructionsRecordsMetaData())
    }
  }, [instructionsAdd])

  useEffect(() => {
    instructionsList
  }, [instructionsList])

  const updateInstructions = (record, success) => {
    const instructionUpdate = {
      leadId: instructionsList.leadId,
      leadQuotationSpecialInstructionId: instructionsList.specialInstructionsId,
      specialInstruction: {
        departmentId: department.value,
        teamId: team.value,
        remarks: instructionsList.remarks,
      },
    }

    specificDispatch(
      quotationAction.updateInstruction(instructionUpdate, record, success)
    )

    setTimeout(() => {
      specificDispatch(quotationAction.loadInstructions(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      setUpdateInstruction(false)
      setSpecialInstructionSet(false)
    }, 2000)
  }

  const [instructionsId, setInstructionsId] = useState("")

  const removeSpecialInstruction = (success) => {
    const leadId = id
    const leadQuotationSpecialInstructionId = instructionsId

    specificDispatch(
      quotationAction.deleteInstruction(
        leadId,
        leadQuotationSpecialInstructionId,
        success
      )
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadInstructions(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
    }, 3000)
  }

  //Photography Event list

  const [eventCheckList, setEventCheckList] = useState({
    description: "",
  })

  const [photographyCheckList, setPhotographyCheckList] = useState(false)

  const checklistChange = (e) => {
    setEventCheckList({
      ...eventCheckList,
      [e.target.name]: e.target.value,
    })
  }

  const addphotography = () => {
    setEventCheckList({
      description: "",
    })
    setPhotographyCheckList(true)
    setRenderPage(true)
  }

  const [eventCheckListId, setEventCheckListId] = useState("")

  //Add checklist
  const handleChecklist = (success) => {
    const checklistUpdate = {
      leadId: id,
      checkList: [
        {
          description: eventCheckList.description,
        },
      ],
    }
    specificDispatch(
      quotationAction.createPhotography(checklistUpdate, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadPhotography(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      setPhotographyCheckList(false)
    }, 2000)
  }

  //Edit checklist
  const editChecklists = (item) => {
    setEventCheckList({
      ...eventCheckList,
      checklistId: item._id,
      description: item.description,
    })
    setUpdateChecklist(true)
    setPhotographyCheckList(true)
  }

  useEffect(() => {
    eventCheckList
  }, [eventCheckList])

  //Update checklist
  const updateChecklists = (success) => {
    const checklistData = {
      leadId: id,
      leadQuotationCheckListId: eventCheckList.checklistId,
      checkList: { description: eventCheckList.description },
    }
    specificDispatch(quotationAction.updatePhotography(checklistData, success))
    setTimeout(() => {
      specificDispatch(quotationAction.loadPhotography(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
      setPhotographyCheckList(false)
      setUpdateChecklist(false)
    }, 2000)
  }

  //Delete checklist
  const removePhotography = (success) => {
    const leadId = id
    const leadQuotationCheckListId = eventCheckListId
    specificDispatch(
      quotationAction.deletePhotography(
        leadId,
        leadQuotationCheckListId,
        success
      )
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadPhotography(id))
      dispatch(
        followupAction.loadRecordsLeadCarryForwardListData({ leadId: id })
      )
    }, 2000)
  }
  //Quotation Event Total Functionality

  const eventQuoteTotal =
    eventDataTable.length > 0 &&
    eventDataTable
      .map((data) => data.value)
      .reduce((a, b) => {
        if (a == 0 || a == undefined) {
          return parseInt(b) + 0
        } else if (b == 0 || b == undefined) {
          return parseInt(a) + 0
        } else {
          return parseInt(a) + parseInt(b)
        }
      })
  const eventDiscountTotal =
    eventDataTable.length > 0 &&
    eventDataTable
      .map((data) => data.discount)
      .reduce((a, b) => {
        if (a == 0 || a == undefined) {
          return parseInt(b) + 0
        } else if (b == 0 || b == undefined) {
          return parseInt(a) + 0
        } else {
          return parseInt(a) + parseInt(b)
        }
      })

  const eventUpsellingTotal =
    eventDataTable.length > 0 &&
    eventDataTable
      .map((data) => data.upselling)
      .reduce((a, b) => {
        if (a == 0 || a == undefined) {
          return parseInt(b) + 0
        } else if (b == 0 || b == undefined) {
          return parseInt(a) + 0
        } else {
          return parseInt(a) + parseInt(b)
        }
      })

  const eventFinalAmount =
    eventDataTable.length > 0 &&
    eventDataTable
      .map((data) => data.amount)
      .reduce((a, b) => {
        if (a == 0 || a == undefined) {
          return parseInt(b) + 0
        } else if (b == 0 || b == undefined) {
          return parseInt(a) + 0
        } else {
          return parseInt(a) + parseInt(b)
        }
      })

  //Quotation Total values functionality

  const deliverQuantityTotal =
    !isEmpty(deliverableData) &&
    deliverableData
      .map((data) => data.quantity)
      .reduce((a, b) => {
        return parseInt(a) + parseInt(b)
      })
  const deliverQuoteTotal =
    !isEmpty(deliverableData) &&
    deliverableData
      .map((data) => data.actualPrice)
      .reduce((a, b) => {
        return parseInt(a) + parseInt(b)
      })
  const deliverDiscountTotal =
    !isEmpty(deliverableData) &&
    deliverableData
      .map((data) => data.discount)
      .reduce((a, b) => {
        return parseInt(a) + parseInt(b)
      })

  const deliverUpsellingTotal =
    !isEmpty(deliverableData) &&
    deliverableData
      .map((data) => data.upselling)
      .reduce((a, b) => {
        return parseInt(a) + parseInt(b)
      })

  const deliverFinalAmount =
    !isEmpty(deliverableData) &&
    deliverableData
      .map((data) => data.finalAmount)
      .reduce((a, b) => {
        return parseInt(a) + parseInt(b)
      })

  const deliverAmountTotal = !isEmpty(deliverFinalAmount)
    ? parseInt(deliverFinalAmount)
    : 0
  console.log(deliverAmountTotal)

  const handlePreviewModalClose = () => setOpenPreviewModal(false)

  //Layout segment
  const handlePreviewModalSubmit = () => {
    setOpenPreviewModal(false)

    var leadNoValue = serviceTotal.leadNo + "_" + companyName
    let bufferObj = Buffer.from(leadNoValue, "utf8")
    let base64String = bufferObj.toString("base64")

    const segmentPreview = {
      leadId: id,
      segmentId: segmentCheckBoxCheckedValue,
    }

    dispatch(quotationAction.addSegmentPreview(segmentPreview))

    setTimeout(() => {
      specificDispatch(
        clientAction.loadRecordClientProfileById({ clientId: leadClientId })
      )
      var path =
        segmentCheckBoxDetail.layoutLink +
        "?type=" +
        id +
        "&&key=" +
        base64String
      window.open(path)
    }, 2000)
  }

  const path = () => {
    var leadNoValue = serviceTotal.leadNo + "_" + companyName
    let bufferObj = Buffer.from(leadNoValue, "utf8")
    let base64String = bufferObj.toString("base64")
    var path = segmentIdDetails[0] + "?type=" + id + "&&key=" + base64String
    window.open(path)
  }
  const handlePreviewModalSubmitClose = () => setOpenPreviewSubmitModal(false)
  //preview End
  const quotationId = leadQuotationId
  // const leadId = id

  const handleQuotationSubmit = (success) => {
    const quotationList = {
      leadId: id,
      quotationId: quotationId,
      isQuotation: "true",
    }
    specificDispatch(
      quotationAction.updateQuotationList(quotationList, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadQuotationList(id))
      specificDispatch(quotationAction.loadServiceTotal(id))
      toast.success("Quotation Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setQuotationLoading(false)
    }, 2000)
    setQuotationLoading(true)
  }

  const handleQuotationUpdate = (success) => {
    const quotationList = {
      leadId: id,
      quotationId: quotationId,
      isQuotation: "true",
    }
    specificDispatch(
      quotationAction.updateQuotationList(quotationList, success)
    )
    setTimeout(() => {
      specificDispatch(quotationAction.loadQuotationList(id))
      specificDispatch(quotationAction.loadServiceTotal(id))
      toast.success("Quotation Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setQuotationLoading(false)
    }, 2000)
    setQuotationLoading(true)
  }

  const isQuotation = !isEmpty(quotationList) && quotationList[0].isQuotation
  const quotationDetailsId = !isEmpty(quotationList) && quotationList[0]._id
  const reviseList = qc_history.reviseList
  const reviseCountDetails = qc_history.reviseCount
  const alterReviseList = alter_quote_history
  var alterReviseCount =
    !isEmpty(alter_quote_history) && alter_quote_history.reviseCount
      ? alter_quote_history.reviseCount
      : ""
  const qcHistoryRemarks =
    reviseCountDetails === 0
      ? []
      : reviseCountDetails > 0
      ? reviseList[reviseList.length - 1].remarks
      : []
  const alterQuoteRemarks =
    alterReviseList.length > 0
      ? alterReviseList[alterReviseList.length - 1].remarks
      : []

  // const qcHistoryRemarks = ""

  //Expiry Date

  const expiryChange = (e) => {
    setExpiry(e)
    const data = moment(e).format("YYYY-MM-DD")
    let expiryDate = {
      leadId: id,
      quotationId: quotationDetailsId,
      quotationExpiryDate: data,
    }
    specificDispatch(quotationAction.updateExpiryDate(expiryDate))
    setTimeout(() => {
      specificDispatch(quotationAction.loadServiceTotal(id))
    }, 2000)
  }

  useEffect(() => {
    if (!isEmpty(service_total_account.quotationExpiryDate)) {
      const expiryDate = moment(
        service_total_account.quotationExpiryDate
      ).format("YYYY-MM-DD")
      setExpiry({
        ...expiry,
        expiryDate: expiryDate,
      })
    }
  }, [service_total_account])

  //Unassigned lead Conditions

  useEffect(() => {
    if (qcSentProcessStatus === "PS8" || isQuotation === false) {
      setRequestQc(false)
    } else if (
      salesManagerId === "6320da65812dfec5383565f4" ||
      qcSentProcessStatus === "PS5" ||
      qcSentProcessStatus === "PS3" ||
      isQuotation === true
    ) {
      setRequestQc(true)
    }
  }, [quotationList, salesManagerId, qcSentProcessStatus])

  return (
    <React.Fragment>
      <Row>
        {/* Button Section */}
        <Col
          md="12"
          lg="12"
          xl="12"
          sm="12"
          xs="12"
          className="quote-head-content"
        >
          <Row>
            <Col md="12" xl="3" lg="3" sm="12" xs="12" className="mb-3">
              <p className="quote-head">
                Quotation
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="quoteInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="quoteInfo">
                    Quotation Details Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            <Col
              md="12"
              xl="9"
              lg="9"
              sm="12"
              xs="12"
              className="button-content"
            >
              <Row>
                <Col className="preview-display-content">
                  <div
                    style={{
                      color: "#34c28f",
                      border: "1.8px solid #34c28f",
                      borderRadius: "4px",
                      padding: "4px 10px",
                      height: "30px",
                      width: "max-content",
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    className={
                      qcSentProcessStatus === "PS8" ||
                      qcSentProcessStatus === "PS6" ||
                      qcSentProcessStatus === "PS19" ||
                      qcSentProcessStatus === "PS9"
                        ? "disabled-button"
                        : (qcSentProcessStatus === "PS17" &&
                            isQuotation === true) ||
                          requestQc === true
                        ? ""
                        : "disabled-button"
                    }
                    onClick={() => {
                      setRequestModal(true)
                      setRequestQc(true)
                    }}
                  >
                    <i className="fas fa-plus mx-1"></i>Request QC Approval
                  </div>
                  <div
                    style={{
                      color: "#f1b44c",
                      border: "1.8px solid #f1b44c",
                      borderRadius: "4px",
                      padding: "4px 10px",
                      height: "30px",
                      width: "max-content",
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    <i className="fas fa-plus mx-1"></i>Call Now
                  </div>
                  <div
                    style={{
                      color: "#007aff",
                      border: "1.8px solid #007aff",
                      borderRadius: "4px",
                      padding: "4px 10px",
                      height: "30px",
                      width: "max-content",
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    className={
                      service_total_account.isAlterStatus === false ||
                      qcSentProcessStatus === "PS2"
                        ? "disabled-button"
                        : service_total_account.isAlterStatus === true ||
                          managerView ||
                          (qc_layout_master &&
                            qc_layout_master[0] &&
                            qc_layout_master[0]._id)
                        ? ""
                        : ""
                    }
                    onClick={() => {
                      if (isEmpty(segmentId)) {
                        setOpenPreviewModal(true)
                        if (
                          qc_layout_master &&
                          qc_layout_master[0] &&
                          qc_layout_master[0]._id
                        )
                          qCLayoutMasterChange(qc_layout_master[0]._id)
                        setActiveTab(qc_layout_master[0].layoutName)
                      } else {
                        path()
                      }
                    }}
                  >
                    <i className="fas fa-eye mx-1"></i>Preview
                  </div>{" "}
                  <div className="preview-checkbox">
                    <Input
                      type="checkbox"
                      name="previewChecked"
                      value={previewChecked}
                      disabled={
                        service_total_account.isAlterStatus === false ||
                        qcSentProcessStatus === "PS2"
                          ? true
                          : false
                      }
                      defaultChecked={
                        serviceTotal.isPreviewShown === true
                          ? true
                          : serviceTotal.isPreviewShown === false
                          ? false
                          : true
                      }
                      onChange={(e) => setPreviewChecked(e.target.checked)}
                    ></Input>
                  </div>
                </Col>
              </Row>
              {requestModal && (
                <Modal show={requestModal} onHide={handleRequestClose}>
                  <Modal.Header>Quotation request</Modal.Header>
                  <Modal.Body>
                    Are you sure you want to Send the QC Approval ?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleRequestClose}
                    >
                      Close
                    </Button>
                    {/* <Link to={"/sales-approval"}> */}
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleApproval()
                      }}
                    >
                      Accept
                    </Button>
                    {/* </Link> */}
                  </Modal.Footer>
                </Modal>
              )}
            </Col>
          </Row>
        </Col>
        {/* Value section */}
        <Col xl="12" lg="12" md="12" className="mt-3 mb-3">
          <Row>
            <Col lg="" md="6" sm="6" xs="12">
              <div className="value-content">
                <h2 className="value-title">Actual Value</h2>
                <h1 className="value-total">
                  Rs.{" "}
                  {!isEmpty(serviceTotal) &&
                  serviceTotal.actualAmountWithoutInsertValue
                    ? serviceTotal.actualAmountWithoutInsertValue
                    : 0}
                </h1>
              </div>
            </Col>
            <Col lg="" md="6" sm="6" xs="12">
              <div className="value-content">
                <h2 className="value-title">Insert Value</h2>
                <h1 className="value-total">
                  Rs.{" "}
                  {!isEmpty(serviceTotal) && serviceTotal.insertedTotalAmount}
                </h1>
              </div>
            </Col>
            <Col lg="" md="6" sm="6" xs="12">
              <div className="value-content">
                <h2 className="value-title">Upselling</h2>
                <h1 className="value-total">
                  Rs. {!isEmpty(serviceTotal) && serviceTotal.upselling}{" "}
                </h1>
              </div>
            </Col>
            <Col lg="" md="6" sm="6" xs="12">
              <div className="value-content">
                <h2 className="value-title">Total Value</h2>
                <h1 className="value-total">
                  Rs. {!isEmpty(serviceTotal) && serviceTotal.actualAmount}
                </h1>
              </div>
            </Col>
            <Col lg="" md="6" sm="6" xs="12">
              <Row className="d-flex flex-row">
                <Col lg="11" md="11" sm="11" xs="11">
                  <div className="value-content">
                    <h2 className="value-title">Discount</h2>
                    <h1 className="value-total d-flex flex-row justify-content-center">
                      Rs.{" "}
                      <span>
                        {!isEmpty(serviceTotal) && serviceTotal.discount}
                      </span>{" "}
                      <span>
                        (
                        {!isEmpty(serviceTotal) &&
                        serviceTotal.discountPercentage
                          ? Math.round(serviceTotal.discountPercentage) + "%"
                          : "0 %"}
                        )
                      </span>
                    </h1>
                  </div>
                </Col>
                <Col lg="1" md="1" sm="1" xs="1">
                  <div className="mx-1">
                    <Input
                      type="checkbox"
                      name="discountChecked"
                      value={discountChecked}
                      className="discount-checkbox"
                      defaultChecked={
                        serviceTotal.isDiscontPreview === true
                          ? true
                          : serviceTotal.isDiscontPreview === false
                          ? false
                          : true
                      }
                      onChange={(e) => {
                        setDiscountChecked(e.target.checked)
                      }}
                    ></Input>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg="" md="6" sm="6" xs="12" className="service-total-amount">
              <div className="value-content">
                <h2 className="value-title">Total Payable</h2>
                <h1 className="value-total">
                  Rs. {!isEmpty(serviceTotal) && serviceTotal.totalAmount}{" "}
                </h1>
              </div>
            </Col>
          </Row>
        </Col>
        {isQuotation === true ||
        (isQuotation === false && qcSentProcessStatus === "PS17") ||
        qcSentProcessStatus === "PS7" ? (
          <Col lg="12" xl="12" md="12" sm="12" xs="12" className="qc-revision">
            <Row className="event-card-content">
              <Col lg="4" xl="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Revision</Label>
                <Input
                  type="text"
                  name="revision"
                  value={
                    qcSentProcessStatus === "PS17"
                      ? alterReviseCount
                      : reviseCount
                  }
                  disabled
                  placeholder="Enter Revise Count"
                />
              </Col>
              <Col lg="4" xl="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Quotation No</Label>
                <Input
                  type="text"
                  name="quotationNo"
                  value={quotationNumber}
                  disabled
                  placeholder="Enter Start Time"
                />
              </Col>
              <Col lg="4" xl="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Quotation Date & Time</Label>
                <Input
                  type="text"
                  name="quotationDate"
                  value={quotationDate}
                  disabled
                  placeholder="Enter Start Time"
                />
              </Col>
              <Col
                xl="8"
                lg="8"
                md="8"
                sm="12"
                xs="12"
                className="d-flex flex-column mt-3"
              >
                {qcSentProcessStatus === "PS17" ? (
                  <>
                    <div className="d-flex flex-row justify-content-between">
                      <Label
                        className="event-label"
                        // style={{ marginBottom: "-10px" }}
                      >
                        Remarks (Alter Qc Approved / Recheck)
                      </Label>
                      <div>
                        <label
                          style={{
                            color: "#4486eb",
                            cursor: "pointer",
                            textDecorationLine: "underline",
                            marginRight: "12px",
                            fontSize: "11px",
                          }}
                          onClick={() => setHistoryForm(true)}
                        >
                          Qc History
                        </label>
                        <label
                          style={{
                            color: "#4486eb",
                            cursor: "pointer",
                            textDecorationLine: "underline",
                            fontSize: "11px",
                          }}
                          onClick={() => setAlterHistoryForm(true)}
                        >
                          Alter Quote History
                        </label>
                      </div>
                    </div>
                    <textarea
                      type="text"
                      name="remarks"
                      value={alterQuoteRemarks}
                      disabled
                      // disabled={
                      //   salesManagerRoleId === "6320da65812dfec5383565f4"
                      //     ? false
                      //     : true
                      // }
                      // onChange={(e) => setAlterRemarks(e.target.value)}
                      placeholder="Enter Remarks"
                      className="event-crowd-textarea"
                    />
                  </>
                ) : (
                  <>
                    <div className="d-flex flex-row justify-content-between">
                      {" "}
                      <Label className="event-label">
                        Remarks (QC Approved / QC Recheck)
                      </Label>
                      <div>
                        <label
                          style={{
                            color: "#4486eb",
                            cursor: "pointer",
                            textDecorationLine: "underline",
                            fontSize: "11px",
                            marginRight: "12px",
                          }}
                          onClick={() => setHistoryForm(true)}
                        >
                          Qc History
                        </label>
                        <label
                          style={{
                            color: "#4486eb",
                            cursor: "pointer",
                            fontSize: "11px",
                            textDecorationLine: "underline",
                          }}
                          onClick={() => setAlterHistoryForm(true)}
                        >
                          Alter Quote History
                        </label>
                      </div>
                    </div>
                    <textarea
                      type="text"
                      name="remarks"
                      value={qcHistoryRemarks}
                      disabled
                      // disabled={
                      //   salesManagerRoleId === "6320da65812dfec5383565f4"
                      //     ? false
                      //     : true
                      // }
                      // onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter Remarks"
                      className="event-crowd-textarea"
                    />
                  </>
                )}
              </Col>
              <Col lg="4" xl="4" md="4" sm="12" xs="12" className="mt-3">
                <Label className="event-label">Expiry Date</Label>
                <Input
                  type="date"
                  name="expiryDate"
                  value={expiry.expiryDate}
                  disabled={qcSentProcessStatus === "PS8" ? true : false}
                  onChange={(e) => expiryChange(e.target.value)}
                  // disabled
                  placeholder="Select Date"
                />
                {!isEmpty(service_total_account.quotationExpiryDate) ? (
                  <div style={{ color: "green", marginTop: "4px" }}>
                    <i className="fa fa-check add-new-venue">Updated</i>
                  </div>
                ) : (
                  // </p>
                  <div className="add-new-venue" style={{ color: "#eb0f0f" }}>
                    Not yet updated
                  </div>
                )}
              </Col>

              {historyForm && (
                <Modal show={historyForm} onHide={handleHistoryClose} size="lg">
                  <Modal.Header>Quotation QC History</Modal.Header>
                  <Modal.Body>
                    <Table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Revised Type</th>
                          <th>Responsed By</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {salesManagerRoleId === "6320da65812dfec5383565f4" ? (
                          <>
                            {" "}
                            {!isEmpty(historyDetails) &&
                            historyDetails.length > 0 ? (
                              historyDetails.map((history) => {
                                return (
                                  <tr key={history._id}>
                                    <td>
                                      {moment(history.quotationDate).format(
                                        "DD-MM-YYYY hh:mm A"
                                      )}
                                    </td>
                                    <td>{history.quotationQcMode}</td>
                                    <td>{history.responsedBy}</td>
                                    <td>{history.remarks}</td>
                                  </tr>
                                )
                              })
                            ) : (
                              <>
                                {" "}
                                <tr key={0}>
                                  <td colSpan={6} className="text-align-center">
                                    {"No Data Found"}
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {" "}
                            {!isEmpty(historyDetails) &&
                              historyDetails.map((history) => {
                                if (history.reviseCount === 0) {
                                  return (
                                    <tr key={0}>
                                      <td
                                        colSpan={6}
                                        className="text-align-center"
                                      >
                                        {"No Data Found"}
                                      </td>
                                    </tr>
                                  )
                                } else {
                                  return (
                                    <tr key={history._id}>
                                      <td>
                                        {moment(history.quotationDate).format(
                                          "DD-MM-YYYY hh:mm A"
                                        )}
                                      </td>
                                      <td>{history.quotationQcMode}</td>
                                      <td>{history.responsedBy}</td>
                                      <td>{history.remarks}</td>
                                    </tr>
                                  )
                                }
                              })}
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleHistoryClose}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </Row>
          </Col>
        ) : service_total_account.actualAmount === 0 ? (
          ""
        ) : (
          ""
        )}
        {alterHistoryForm && (
          <Modal
            show={alterHistoryForm}
            onHide={handleAlterRequestClose}
            size="lg"
          >
            <Modal.Header>Alter Quote QC History</Modal.Header>
            <Modal.Body>
              <Table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Revised Type</th>
                    <th>Responsed By</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {salesManagerRoleId === "6320da65812dfec5383565f4" ? (
                    <>
                      {" "}
                      {!isEmpty(alterHistoryDetails) &&
                      alterHistoryDetails.length > 0 ? (
                        alterHistoryDetails.map((history) => {
                          return (
                            <tr key={history._id}>
                              <td>
                                {moment(history.leadQuotationDate).format(
                                  "DD-MM-YYYY hh:mm A"
                                )}
                              </td>
                              <td>{history.mode}</td>
                              <td>{history.alterResponsedBy}</td>
                              <td>{history.remarks}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <>
                          {" "}
                          <tr key={0}>
                            <td colSpan={6} className="text-align-center">
                              {"No Data Found"}
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {" "}
                      {!isEmpty(alterHistoryDetails) &&
                        alterHistoryDetails.map((history) => {
                          if (history.reviseCount === 0) {
                            return (
                              <tr key={0}>
                                <td colSpan={6} className="text-align-center">
                                  {"No Data Found"}
                                </td>
                              </tr>
                            )
                          } else {
                            return (
                              <tr key={history._id}>
                                <td>
                                  {moment(history.quotationDate).format(
                                    "DD-MM-YYYY hh:mm A"
                                  )}
                                </td>
                                <td>{history.mode}</td>
                                <td>{history.alterResponsedBy}</td>
                                <td>{history.remarks}</td>
                              </tr>
                            )
                          }
                        })}
                    </>
                  )}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleAlterRequestClose}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* Value Insert */}
        <Col md="12" xl="12" lg="12" className="mt-2">
          <Row>
            <Col lg="9" md="9" sm="6" xs="6">
              <p className="special-info">
                Value Insert
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="specialInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="specialInfo">
                    Value Insert Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            {/* <Col lg="3" md="3" sm="6" xs="6">
              {managerView ||
              qcSentProcessStatus === "PS8" ||
              qcSentProcessStatus === "PS6" ||
              service_total_account.insertedTotalAmount > 0 ||
              qcSentProcessStatus === "PS9" ? (
                ""
              ) : (
                <div
                  className="add-more-instructions"
                  onClick={() => {
                    addValueInsert()
                  }}
                >
                  Add More
                </div>
              )}
            </Col> */}
          </Row>
        </Col>
        <Col md="12" lg="12" xl="12" className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th>Insert Amount</th>
                <th>Insert Percentage</th>
                {service_total_account.insertedTotalAmount < 1 ? (
                  <>
                    <th style={{ textAlign: "center" }}>#</th>
                  </>
                ) : (
                  <>
                    <th>Total Amout(Amount + %)</th>
                  </>
                )}
                {updateValueInsert ||
                service_total_account.insertedTotalAmount < 1 ? (
                  ""
                ) : (
                  <>
                    {" "}
                    <th
                      className="icon-section"
                      style={{ textAlign: "center" }}
                    >
                      #
                    </th>
                    <th className="icon-section">#</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {updateValueInsert ||
              service_total_account.insertedTotalAmount < 1 ? (
                <tr>
                  <td style={{ width: "25%" }}>
                    <Input
                      name="insertAmount"
                      value={insertList.insertAmount}
                      placeholder="Enter Amount"
                      onChange={(e) => valueInsertChange(e)}
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <Input
                      name="insertPercentage"
                      value={insertList.insertPercentage}
                      placeholder="Enter Percentage"
                      onChange={(e) => valueInsertChange(e)}
                    />
                  </td>

                  {updateValueInsert ? (
                    <td style={{ width: "15%" }}>
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setUpdateValueInsert(false)
                            //  setValueInsertSet(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-info"
                          onClick={() => updateValueInsertDetails()}
                        >
                          update
                        </div>
                      </div>
                    </td>
                  ) : service_total_account.insertedTotalAmount < 1 ? (
                    <td
                      style={{ width: "15%", textAlign: "center" }}
                      className="w-10"
                    >
                      <div className="d-flex flex-row justify-content-center">
                        <div
                          className={
                            qcSentProcessStatus === "PS9" ||
                            qcSentProcessStatus === "PS19"
                              ? "disabled-button add-button btn btn-success"
                              : "add-button btn btn-success"
                          }
                          onClick={() => handleValueInsert()}
                        >
                          Add
                        </div>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ) : (
                <>
                  <tr>
                    <td>
                      {!isEmpty(service_total_account) &&
                      service_total_account.insertedAmount
                        ? service_total_account.insertedAmount
                        : ""}
                    </td>
                    <td>
                      {!isEmpty(service_total_account) &&
                      service_total_account.insertedPercentage
                        ? service_total_account.insertedPercentage
                        : ""}
                    </td>
                    <td style={{ width: "25%" }}>
                      <p className="value-total">
                        {!isEmpty(service_total_account) &&
                        service_total_account.overallInsertedTotalAmount
                          ? service_total_account.overallInsertedTotalAmount
                          : ""}
                      </p>
                    </td>
                    <td>
                      {managerView ||
                      qcSentProcessStatus === "PS8" ||
                      qcSentProcessStatus === "PS6" ||
                      qcSentProcessStatus === "PS19" ||
                      qcSentProcessStatus === "PS9" ? (
                        <button
                          type="submit"
                          className="add-button disabled-button"
                          disabled
                          onClick={() => {
                            editValueInsertDetails(service_total_account)
                          }}
                        >
                          Edit
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="add-button"
                          onClick={() => {
                            editValueInsertDetails(service_total_account)
                          }}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                    <td>
                      {managerView ||
                      qcSentProcessStatus === "PS8" ||
                      qcSentProcessStatus === "PS6" ||
                      qcSentProcessStatus === "PS19" ||
                      qcSentProcessStatus === "PS9" ? (
                        <i
                          className="fa fa-times remove-icon disabled-button"
                          onClick={() => {
                            setValueDeleteInsertForm(true)
                          }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-times remove-icon"
                          onClick={() => {
                            setValueDeleteInsertForm(true)
                          }}
                        ></i>
                      )}
                    </td>
                  </tr>{" "}
                </>
              )}
            </tbody>
          </Table>
        </Col>
        {valueDeleteInsertForm && (
          <Modal show={valueDeleteInsertForm} onHide={handleValueInsertClose}>
            <Modal.Header>Delete Event Details</Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the Event details ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleValueInsertClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleValueInsertClose()
                  deleteValueInsertDetails()
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {/* Event Details Section */}
        <Col className="quote-head-content">
          <p className="quote-head">Event Details</p>

          {/* //  }  */}
          {qcSentProcessStatus === "PS8" ||
          qcSentProcessStatus === "PS6" ||
          qcSentProcessStatus === "PS19" ||
          qcSentProcessStatus === "PS9" ? (
            ""
          ) : (
            <div
              className="quote-event-button"
              onClick={() => handleAddEvent()}
            >
              <i className="fas fa-plus"></i> Add Event
            </div>
          )}
        </Col>
        <Table striped bordered responsive className="mt-3 mb-2">
          <thead>
            <tr style={{ fontSize: "10px" }}>
              <th>S.No</th>
              <th>Actions</th>
              <th>Event No</th>
              <th>Event Name</th>
              <th>Event Type</th>
              <th style={{ minWidth: "110px" }}>Event Date</th>
              <th style={{ minWidth: "90px" }}>Main Event</th>
              <th>Time</th>
              <th>Location</th>
              <th style={{ minWidth: "85px" }}>Total Value</th>
              <th style={{ minWidth: "101px" }}>Total Upselling</th>
              <th>Discount</th>
              <th style={{ minWidth: "101px" }}>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {eventDataTable.length > 0 ? (
              eventDataTable.map((events) => {
                return (
                  <tr key={events._id}>
                    <td>{events.sNo}</td>
                    <td
                      className="d-flex flex-row"
                      style={{ paddingBottom: "40px" }}
                    >
                      {managerView ||
                      qcSentProcessStatus === "PS8" ||
                      qcSentProcessStatus === "PS6" ||
                      qcSentProcessStatus === "PS19" ||
                      qcSentProcessStatus === "PS9" ? (
                        <>
                          <Button
                            type="submit"
                            style={{ fontSize: "8px" }}
                            disabled
                            onClick={() => {
                              editEventDetails(events)
                            }}
                            className="btn btn-success"
                          >
                            <i className="fas fa-edit icon-btn"></i>
                          </Button>
                          <Button
                            type="submit"
                            style={{ fontSize: "8px" }}
                            onClick={() => {
                              editEventDetails(events)
                              setRequestView(true)
                            }}
                            className="mx-1 btn btn-info"
                          >
                            <i className="fas fa-book icon-btn"></i>
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            type="submit"
                            style={{ fontSize: "8px" }}
                            onClick={() => {
                              editEventDetails(events)
                              setQuotationRemoveId(events._id)
                            }}
                            className="btn btn-success"
                          >
                            <i className="fas fa-edit icon-btn"></i>
                          </Button>
                          <Button
                            type="submit"
                            style={{ fontSize: "8px" }}
                            onClick={() => {
                              setQuotationRemoveId(events.leadQuotationEventId)
                              setDeleteForm(true)
                            }}
                            className="mx-1 btn btn-danger"
                          >
                            <i className="bx bx-block icon-btn"></i>
                          </Button>
                        </>
                      )}
                    </td>
                    <td>{events.eventNo}</td>
                    <td style={{ paddingRight: "50px" }}>{events.eventName}</td>
                    <td>{events.eventTypeName}</td>
                    <td style={{ minWidth: "15%" }}>{events.eventDate}</td>
                    <td>
                      {" "}
                      {events.isMainEvent ? (
                        <Badge
                          color="success"
                          style={{ padding: "6px 8px", fontSize: "12px" }}
                        >
                          Yes
                        </Badge>
                      ) : (
                        <Badge
                          color="danger"
                          style={{ padding: "6px 8px", fontSize: "12px" }}
                        >
                          No
                        </Badge>
                      )}
                    </td>
                    <td>{events.crewAssemblyTime}</td>
                    <td>{events.venueLocation}</td>
                    <td
                      className="event-table-value"
                      style={{ color: "#34c38f" }}
                    >
                      {events.value === undefined
                        ? "0.00"
                        : events.value + ".00"}
                    </td>
                    <td className="event-table-value">
                      {events.upselling === undefined
                        ? "0.00"
                        : events.upselling + ".00"}
                    </td>
                    <td
                      className="event-table-value"
                      style={{ color: "#f1153e" }}
                    >
                      {events.discount === undefined
                        ? "0.00"
                        : events.discount + ".00"}
                    </td>
                    <td
                      className="event-table-value"
                      style={{ color: "#086fc7" }}
                    >
                      {events.amount === undefined
                        ? "0.00"
                        : events.amount + ".00"}
                    </td>
                  </tr>
                )
              })
            ) : (
              <>
                <tr key={0}>
                  <td colSpan={13} className="text-align-center">
                    No record found
                  </td>
                </tr>
              </>
            )}
            {/* {eventDataTable && eventDataTable.length > 0 ? (
                  <> */}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td
                colSpan={7}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  fontWeight: "550",
                }}
              >
                Total Event Cost
              </td>
              <td className="event-table-value" style={{ color: "#34c38f" }}>
                {eventQuoteTotal === undefined ||
                eventDataTable.length === 0 ||
                isNaN(eventQuoteTotal)
                  ? "0.00"
                  : eventQuoteTotal + ".00"}
              </td>
              <td className="event-table-value">
                {eventUpsellingTotal === undefined ||
                eventDataTable.length === 0 ||
                isNaN(eventUpsellingTotal)
                  ? "0.00"
                  : eventUpsellingTotal + ".00"}
              </td>
              <td className="event-table-value" style={{ color: "#f1153e" }}>
                {eventDiscountTotal === undefined ||
                eventDataTable.length === 0 ||
                isNaN(eventDiscountTotal)
                  ? "0.00"
                  : eventDiscountTotal + ".00"}
              </td>
              <td className="event-table-value" style={{ color: "#086fc7" }}>
                {eventFinalAmount === undefined ||
                eventDataTable.length === 0 ||
                isNaN(eventFinalAmount)
                  ? "0.00"
                  : eventFinalAmount + ".00"}
              </td>
            </tr>
          </tbody>
          {deleteForm && (
            <Modal show={deleteForm} onHide={handleClose}>
              <Modal.Header>Delete Event Details</Modal.Header>
              <Modal.Body>
                Are you sure you want to delete the Event details ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handleClose()
                    removeEventDetails()
                  }}
                >
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Table>
        <Col className="mt-2 event-detail-content">
          {managerView || requestView ? (
            <>
              {eventQuotationModal && (
                <form>
                  <Row className="event-card-content">
                    <Col className="mt-2 mb-2">
                      <Row className="">
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Event Type
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="eventType"
                            value={eventType}
                            isDisabled={true}
                            options={
                              quotationRecordsMetaData
                                ? quotationRecordsMetaData.eventTypeOptions
                                : []
                            }
                            onChange={(e) => setEventType(e)}
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label for="eventList" className="event-label">
                            Event List
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="event"
                            value={event}
                            isDisabled={true}
                            options={
                              quotationRecordsMetaData
                                ? quotationRecordsMetaData.eventOptions
                                : []
                            }
                            onChange={(e) => setEvent(e)}
                            id="eventList"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Date</Label>
                          <Input
                            type="date"
                            name="eventDate"
                            disabled
                            value={quotationData.eventDate}
                            onChange={(e) => handleChange(e)}
                            placeholder="Select Date"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Crew Assembly Time
                          </Label>
                          <Input
                            type="time"
                            name="crewAssemblyTime"
                            disabled
                            value={quotationData.crewAssemblyTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter Crew Assembly Time"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Start Time</Label>
                          <Input
                            type="time"
                            name="startTime"
                            disabled
                            value={quotationData.startTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter Start Time"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">End Time</Label>
                          <Input
                            type="time"
                            name="endTime"
                            disabled
                            value={quotationData.endTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter End Time"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            {venueLocationAdd ? (
                              <Label className="event-label">
                                Venue Location
                              </Label>
                            ) : (
                              <Label className="event-label">
                                Venue Location
                              </Label>
                            )}
                            <div
                              className="event-given-checkbox"
                              onClick={() => {
                                handleVenueTab()
                              }}
                            >
                              <Input
                                name="premium"
                                type="checkbox"
                                className="mt-1 event-given-input"
                                checked={venueLocationAdd ? true : false}
                                onClick={() => setNewVenueLocation("")}
                              />
                              <label className="event-given-input-text">
                                Not Given
                              </label>
                            </div>
                          </div>
                          {venueLocationAdd ? (
                            <Input
                              name="newVenueLocation"
                              value={newVenueLocation}
                              onChange={(e) =>
                                setNewVenueLocation(
                                  e.target.value.toUpperCase()
                                )
                              }
                              placeholder="Enter Venue Location"
                              style={{ textTransform: "uppercase" }}
                            />
                          ) : (
                            <Select
                              name="venueLocation"
                              value={venueLocation}
                              options={venueLocationOptions}
                              isDisabled={true}
                              onChange={(e) => handleVenueLocations(e)}
                              placeholder="Select Venue Locations"
                            />
                          )}
                          {venueLocationAdd ? (
                            <>
                              {updateVenue ? (
                                <div
                                  className="add-venue"
                                  onClick={() => updateVenueLocationDetails()}
                                >
                                  Update
                                </div>
                              ) : (
                                <div
                                  className="add-venue"
                                  onClick={() => {
                                    addVenueLocationDetails()
                                    setVenueLocationAdded(true)
                                  }}
                                >
                                  <span>Add</span>
                                </div>
                              )}
                            </>
                          ) : addedVenueLocation ? (
                            <div style={{ color: "green" }}>
                              <i className="fa fa-check add-new-venue">Added</i>
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            {venueAdd ? (
                              <Label className="event-label">
                                New Venue Name
                              </Label>
                            ) : (
                              <Label className="event-label">
                                Venue Name
                                <span className="event-required">*</span>
                              </Label>
                            )}
                            <div
                              className="event-given-checkbox"
                              onClick={() => {
                                handleVenueNameTab()
                              }}
                            >
                              <Input
                                name="premium"
                                type="checkbox"
                                className="mt-1 event-given-input"
                                checked={venueAdd ? true : false}
                              />
                              <label className="event-given-input-text">
                                Not Given
                              </label>
                            </div>
                          </div>
                          {venueAdd ? (
                            <Input
                              name="newVenue"
                              value={newVenue}
                              onChange={(e) => setNewVenue(e.target.value)}
                              placeholder="Enter Venue Name"
                            />
                          ) : (
                            <Select
                              type="text"
                              name="cityVenueName"
                              value={cityVenueName}
                              noOptionsMessage={() => null}
                              showIcon={false}
                              isSearchable
                              autoComplete
                              isDisabled={true}
                              options={cityVenueOptions}
                              onChange={(e) => setCityVenueName(e)}
                              placeholder="Enter Venue Name"
                            />
                          )}
                          <div className="d-flex flex-row">
                            <div>
                              <Input
                                type="checkbox"
                                name="premium"
                                value={premium}
                                disabled
                                className="event-premium-checkbox add-venue-name"
                                onChange={() => setPremium(!premium)}
                              />
                              <Label className="event-label mx-2 mt-1">
                                Premium
                              </Label>
                            </div>
                            {venueAdd ? (
                              <>
                                {updateVenue ? (
                                  <div
                                    className="add-venue"
                                    onClick={() => updateVenueDetails()}
                                  >
                                    Update
                                  </div>
                                ) : (
                                  <div
                                    className="add-venue"
                                    onClick={() => {
                                      addVenueDetails()
                                      setVenueNameAdded(true)
                                    }}
                                  >
                                    <span>Add</span>
                                  </div>
                                )}
                              </>
                            ) : addedVenue ? (
                              <div style={{ color: "green" }}>
                                <i className="fa fa-check add-new-venue">
                                  Added
                                </i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Crowd Strength</Label>
                          <Input
                            type="text"
                            name="crowdStrength"
                            disabled
                            value={quotationData.crowdStrength}
                            onChange={(e) => {
                              const re = /^[0-9\b/+]+$/
                              if (
                                e.target.value === "" ||
                                re.test(e.target.value)
                              ) {
                                handleChange(e)
                              }
                            }}
                            placeholder="Enter Crowd Strength"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Travel</Label>
                          <Select
                            name="travel"
                            value={travel}
                            onChange={(e) => setTravel(e)}
                            options={options}
                            isDisabled={true}
                            placeholder="Select The Travel"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Food</Label>
                          <Select
                            name="food"
                            value={food}
                            isDisabled={true}
                            onChange={(e) => setFood(e)}
                            options={options}
                            placeholder="Select The Food"
                          />{" "}
                        </Col>
                        <Col
                          lg="4"
                          md="4"
                          sm="12"
                          xs="12"
                          className="mt-1 mb-2"
                        >
                          <Label className="event-label">Food</Label>
                          <Select
                            name="food"
                            value={food}
                            onChange={(e) => setFood(e)}
                            options={options}
                            placeholder="Select The Food"
                          />
                        </Col>
                        {/* Event Details table */}
                        <Col lg="12" md="12" xl="12" className="mt-3">
                          <div className="table-event-main">
                            <Row>
                              <Col
                                lg="6"
                                xl="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="table-odd-array"
                              >
                                <Table
                                  striped
                                  responsive
                                  className="table-main"
                                >
                                  <thead className="table-event-head">
                                    <tr>
                                      <th className="table-event-title">
                                        Service Name
                                      </th>
                                      <th className="table-amount">Quantity</th>
                                      <th className="table-amount">Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {oddServiceData &&
                                    oddServiceData.length > 0 ? (
                                      oddServiceData.map((service, index) => {
                                        return (
                                          <tr
                                            className="table-row"
                                            key={service._id}
                                          >
                                            <td>{service.serviceName}</td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="quantity"
                                                disabled
                                                value={service.quantity}
                                                onChange={(e) =>
                                                  changeOddService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "quantity"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Quantity`}
                                              ></Input>
                                            </td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="amount"
                                                disabled
                                                value={service.amount}
                                                onChange={(e) =>
                                                  changeOddService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "amount"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Amount`}
                                                className="h-10"
                                              ></Input>
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <>
                                        <tr key={0}>
                                          <td
                                            colSpan={3}
                                            className="text-align-center"
                                          >
                                            No Records Found
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="table-even-array"
                              >
                                <Table
                                  bordered
                                  striped
                                  responsive
                                  className="table-main"
                                >
                                  <thead className="table-event-head">
                                    <tr>
                                      <th className="table-event-title">
                                        Service Name
                                      </th>
                                      <th className="table-amount">Quantity</th>
                                      <th className="table-amount-1">Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {evenServiceData &&
                                    evenServiceData.length > 0 ? (
                                      evenServiceData.map((service, index) => {
                                        return (
                                          <tr
                                            className="table-row"
                                            key={service._id}
                                          >
                                            <td>{service.serviceName}</td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="quantity"
                                                disabled
                                                value={service.quantity}
                                                onChange={(e) =>
                                                  changeEvenService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "quantity"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Quantity`}
                                              ></Input>
                                            </td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="amount"
                                                disabled
                                                value={service.amount}
                                                onChange={(e) =>
                                                  changeEvenService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "amount"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Amount`}
                                                className="h-10"
                                              ></Input>
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <>
                                        <tr key={0}>
                                          <td
                                            colSpan={3}
                                            className="text-align-center"
                                          >
                                            No Records Found
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col
                          md="12"
                          xl="12"
                          lg="12"
                          className="event-details-submit mt-3"
                        >
                          <>
                            <button
                              onClick={() => {
                                setEventQuotationModal(false)
                                setIsEdit(false)
                                // handleCancel()
                              }}
                              type="button"
                              className="btn btn-danger btn-label form-cancel-btn"
                            >
                              <i className="bx bx-block label-icon "></i>
                              Cancel
                            </button>
                          </>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              )}
            </>
          ) : (
            <>
              {eventQuotationModal && (
                <form>
                  <Row className="event-card-content">
                    <Col className="mt-2 mb-2">
                      <Row className="">
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Event Type
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="eventType"
                            value={eventType}
                            isOptionDisabled={(option) => option.disabled}
                            options={
                              quotationRecordsMetaData
                                ? quotationRecordsMetaData.eventTypeOptions
                                : []
                            }
                            onChange={(e) => setEventType(e)}
                          />
                          {simpleValidator.current.message(
                            "eventType",
                            eventType,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label for="eventList" className="event-label">
                            Event List
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="event"
                            value={event}
                            options={
                              quotationRecordsMetaData
                                ? quotationRecordsMetaData.eventOptions
                                : []
                            }
                            onChange={(e) => setEvent(e)}
                            id="eventList"
                          />
                          {simpleValidator.current.message(
                            "event",
                            event,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Date</Label>
                          <Input
                            type="date"
                            name="eventDate"
                            value={quotationData.eventDate}
                            onChange={(e) => handleChange(e)}
                            placeholder="Select Date"
                          />
                          {/* {simpleValidator.current.message(
                        "eventDate",
                        quotationData.eventDate,
                        "required"
                      )} */}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Crew Assembly Time
                          </Label>
                          <Input
                            type="time"
                            name="crewAssemblyTime"
                            value={quotationData.crewAssemblyTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter Crew Assembly Time"
                          />
                          {/* {simpleValidator.current.message(
                        "crewAssemblyTime",
                        quotationData.crewAssemblyTime,
                        "required"
                      )} */}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Start Time</Label>
                          <Input
                            type="time"
                            name="startTime"
                            value={quotationData.startTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter Start Time"
                          />
                          {/* {simpleValidator.current.message(
                        "startTime",
                        quotationData.startTime,
                        "required"
                      )} */}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">End Time</Label>
                          <Input
                            type="time"
                            name="endTime"
                            value={quotationData.endTime}
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter End Time"
                          />
                          {/* {simpleValidator.current.message(
                        "endTime",
                        quotationData.endTime,
                        "required"
                      )} */}
                        </Col>

                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            {venueLocationAdd ? (
                              <Label className="event-label">
                                Venue Location{" "}
                                {/* <span
                            style={{
                              color: "#50a5f1",
                              marginLeft: "3px",
                              fontWeight: "400",
                            }}
                          >
                            {"(city-state-country)"}
                          </span> */}
                              </Label>
                            ) : (
                              <Label className="event-label">
                                Venue Location
                                {/* <span className="event-required">*</span> */}
                              </Label>
                            )}
                            <div
                              className="event-given-checkbox"
                              onClick={() => {
                                handleVenueTab()
                              }}
                            >
                              <Input
                                name="premium"
                                type="checkbox"
                                className="mt-1 event-given-input"
                                checked={venueLocationAdd ? true : false}
                                onClick={() => setNewVenueLocation("")}
                              />
                              <label className="event-given-input-text">
                                Not Given
                              </label>
                            </div>
                          </div>
                          {venueLocationAdd ? (
                            <Input
                              name="newVenueLocation"
                              value={newVenueLocation}
                              onChange={(e) =>
                                setNewVenueLocation(e.target.value)
                              }
                              placeholder="Enter Venue Location"
                            />
                          ) : (
                            <Select
                              name="venueLocation"
                              value={venueLocation}
                              options={venueLocationOptions}
                              // isSearchable
                              // isClearable
                              // closeMenuOnSelect={true}
                              onChange={(e) => handleVenueLocations(e)}
                              placeholder="Select Venue Locations"
                            />
                          )}
                          {venueLocationAdd ? (
                            <>
                              {updateVenue ? (
                                <div
                                  className="add-venue"
                                  onClick={() => updateVenueLocationDetails()}
                                >
                                  Update
                                </div>
                              ) : (
                                <div
                                  className="add-venue"
                                  onClick={() => {
                                    addVenueLocationDetails()
                                    setVenueLocationAdded(true)
                                  }}
                                >
                                  <span>Add</span>
                                  {/* Add */}
                                </div>
                              )}
                            </>
                          ) : addedVenueLocation ? (
                            <div style={{ color: "green" }}>
                              <i className="fa fa-check add-new-venue">Added</i>
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <div className="d-flex justify-content-between">
                            {venueAdd ? (
                              <Label className="event-label">
                                New Venue Name
                              </Label>
                            ) : (
                              <Label className="event-label">Venue Name</Label>
                            )}
                            <div
                              className="event-given-checkbox"
                              onClick={() => {
                                handleVenueNameTab()
                              }}
                            >
                              <Input
                                name="premium"
                                type="checkbox"
                                className="mt-1 event-given-input"
                                checked={venueAdd ? true : false}
                              />
                              <label className="event-given-input-text">
                                Not Given
                              </label>
                            </div>
                          </div>
                          {venueAdd ? (
                            <Input
                              name="newVenue"
                              value={newVenue}
                              onChange={(e) => setNewVenue(e.target.value)}
                              placeholder="Enter Venue Name"
                            />
                          ) : (
                            <Select
                              type="text"
                              name="cityVenueName"
                              value={cityVenueName}
                              noOptionsMessage={() => null}
                              showIcon={false}
                              isSearchable
                              autoComplete
                              options={cityVenueOptions}
                              onChange={(e) => setCityVenueName(e)}
                              placeholder="Enter Venue Name"
                            />
                          )}
                          <div className="d-flex flex-row">
                            {cityVenueName.isPremium === false ? (
                              ""
                            ) : (
                              <div>
                                <Input
                                  type="checkbox"
                                  // value={venue.premium}
                                  name="premium"
                                  value={premium}
                                  checked={
                                    cityVenueName.isPremium === true
                                      ? true
                                      : premium
                                      ? true
                                      : false
                                  }
                                  className="event-premium-checkbox add-venue-name"
                                  onChange={() => setPremium(!premium)}
                                />
                                <Label className="event-label mx-2 mt-1">
                                  Premium
                                </Label>
                              </div>
                            )}

                            {venueAdd ? (
                              <>
                                <div
                                  className="add-venue"
                                  onClick={() => {
                                    addVenueDetails()
                                    setVenueNameAdded(true)
                                  }}
                                >
                                  <span>Add</span>
                                </div>
                              </>
                            ) : addedVenue ? (
                              <div style={{ color: "green" }}>
                                <i className="fa fa-check add-new-venue">
                                  Added
                                </i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Crowd Strength</Label>
                          <Input
                            type="text"
                            name="crowdStrength"
                            value={quotationData.crowdStrength}
                            onChange={(e) => {
                              const re = /^[0-9\b/+]+$/
                              if (
                                e.target.value === "" ||
                                re.test(e.target.value)
                              ) {
                                handleChange(e)
                              }
                            }}
                            className="client-number-field"
                            placeholder="Enter Crowd Strength"
                          />
                        </Col>
                        <Col
                          lg="4"
                          md="4"
                          sm="12"
                          xs="12"
                          className="mt-1 mb-2"
                        >
                          <Label className="event-label">Travel</Label>
                          <Select
                            name="travel"
                            value={travel}
                            onChange={(e) => setTravel(e)}
                            options={options}
                            placeholder="Select The Travel"
                          />
                        </Col>
                        <Col
                          lg="4"
                          md="4"
                          sm="12"
                          xs="12"
                          className="mt-1 mb-2"
                        >
                          <Label className="event-label">Food</Label>
                          <Select
                            name="food"
                            value={food}
                            onChange={(e) => setFood(e)}
                            options={options}
                            placeholder="Select The Food"
                          />
                        </Col>

                        <Col
                          lg="4"
                          md="4"
                          sm="12"
                          xs="12"
                          className="mt-3 mb-2"
                        >
                          <Input
                            type="checkbox"
                            name="isMainEvent"
                            checked={isMainEvent}
                            onChange={() => setIsMainEvent(!isMainEvent)}
                            className="event-premium-checkbox add-venue-name"
                          />
                          <Label className="event-label mx-2 mt-1">
                            Is Main Event
                          </Label>
                        </Col>
                        {/* Event Details table */}
                        <Col lg="12" md="12" xl="12" className="mt-3">
                          <div className="table-event-main">
                            <Row>
                              <Col
                                lg="6"
                                xl="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="table-odd-array"
                              >
                                <Table
                                  // bordered
                                  striped
                                  responsive
                                  className="table-main"
                                >
                                  <thead className="table-event-head">
                                    <tr>
                                      <th
                                        className="table-event-title"
                                        style={{ marginRight: "10px" }}
                                      >
                                        ServiceName
                                      </th>
                                      <th className="table-amount">Quantity</th>
                                      <th className="table-amount">Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {oddServiceData &&
                                    oddServiceData.length > 0 ? (
                                      oddServiceData.map((service, index) => {
                                        return (
                                          <tr
                                            className="table-row"
                                            key={service._id}
                                          >
                                            <td>{service.serviceName}</td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="quantity"
                                                value={service.quantity}
                                                onChange={(e) =>
                                                  changeOddService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "quantity"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Quantity`}
                                              ></Input>
                                            </td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="amount"
                                                value={service.amount}
                                                onChange={(e) =>
                                                  changeOddService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "amount"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Amount`}
                                                className="h-10"
                                              ></Input>
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <>
                                        <tr key={0}>
                                          <td
                                            colSpan={3}
                                            className="text-align-center"
                                          >
                                            No Records Found
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="6"
                                sm="12"
                                xs="12"
                                className="table-even-array"
                              >
                                <Table
                                  bordered
                                  striped
                                  responsive
                                  className="table-main"
                                >
                                  <thead className="table-event-head">
                                    <tr>
                                      <th
                                        className="table-event-title"
                                        style={{ marginBottom: "18px" }}
                                      >
                                        ServiceName
                                      </th>
                                      <th
                                        className="table-amount"
                                        style={{ marginBottom: "18px" }}
                                      >
                                        Quantity
                                      </th>
                                      <th
                                        className="table-amount-1"
                                        style={{ marginBottom: "18px" }}
                                      >
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {evenServiceData &&
                                    evenServiceData.length > 0 ? (
                                      evenServiceData.map((service, index) => {
                                        return (
                                          <tr
                                            className="table-row"
                                            key={service._id}
                                          >
                                            <td>{service.serviceName}</td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="quantity"
                                                value={service.quantity}
                                                onChange={(e) =>
                                                  changeEvenService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "quantity"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Quantity`}
                                              ></Input>
                                            </td>
                                            <td className="table-input">
                                              <Input
                                                type="text"
                                                pattern="0-9"
                                                name="amount"
                                                value={service.amount}
                                                onChange={(e) =>
                                                  changeEvenService(
                                                    e,
                                                    index,
                                                    service._id,
                                                    "amount"
                                                  )
                                                }
                                                placeholder={`Enter ${service.serviceName} Amount`}
                                                className="h-10"
                                              ></Input>
                                            </td>
                                          </tr>
                                        )
                                      })
                                    ) : (
                                      <>
                                        <tr key={0}>
                                          <td
                                            colSpan={3}
                                            className="text-align-center"
                                          >
                                            No Records Found
                                          </td>
                                        </tr>
                                      </>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col
                          md="12"
                          xl="12"
                          lg="12"
                          className="event-details-submit mt-3"
                        >
                          {isEdit ? (
                            <>
                              <button
                                onClick={() => {
                                  setEventQuotationModal(false)
                                  setIsEdit(false)
                                  window.scrollTo(0, 800)

                                  // handleCancel()
                                }}
                                type="button"
                                className="btn btn-danger btn-label form-cancel-btn"
                              >
                                <i className="bx bx-block label-icon "></i>
                                Cancel
                              </button>
                              <button
                                type="submit"
                                onClick={(event) => {
                                  setEventQuotationModal(false)
                                  handleUpdate(event)
                                  setIsEdit(false)
                                }}
                                className="btn btn-success btn-label form-submit-btn"
                              >
                                <i className="bx bx-check-double label-icon"></i>
                                Update
                              </button>
                            </>
                          ) : (
                            <>
                              {" "}
                              <button
                                onClick={() => {
                                  // handleCancel()
                                  window.scrollTo(0, 800)
                                  // forceUpdate()
                                  setEventQuotationModal(false)
                                }}
                                type="button"
                                className="btn btn-danger btn-label form-cancel-btn"
                              >
                                <i className="bx bx-block label-icon "></i>
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEventQuotationModal(false)
                                  handleSubmit()
                                }}
                                className="btn btn-success btn-label form-submit-btn"
                              >
                                <i className="bx bx-check-double label-icon"></i>
                                Submit
                              </button>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              )}{" "}
            </>
          )}
        </Col>
        {/* Event details End */}

        <Col lg="12" md="12" xl="12" className="quote-head-content">
          <p className="quote-head">
            Deliverables Details
            <span className="quote-info">
              <i
                style={{ color: "grey" }}
                id="DeliverablesInfo"
                aria-hidden="true"
                className="fa fa-info-circle ms-1"
              ></i>
              <UncontrolledTooltip placement="right" target="DeliverablesInfo">
                Deliverables Details Description
              </UncontrolledTooltip>
            </span>
          </p>
          {qcSentProcessStatus === "PS8" ||
          qcSentProcessStatus === "PS6" ||
          qcSentProcessStatus === "PS19" ||
          qcSentProcessStatus === "PS9" ? (
            ""
          ) : (
            <div
              className="quote-event-button"
              onClick={() => handleAddDeliverable()}
            >
              <i className="fas fa-plus"></i> Add Deliverables
            </div>
          )}
        </Col>
        <Col md="12" lg="12" xl="12">
          <Table striped responsive className="w-100 mt-3 mb-2">
            <thead>
              <tr style={{ fontSize: "10px" }}>
                <th>S.No</th>
                <th style={{ minWidth: "120px" }}>Actions</th>
                <th style={{ minWidth: "140px" }}>Event No</th>
                <th style={{ minWidth: "140px" }}>Event Name</th>
                <th style={{ minWidth: "140px" }}>Deliverable Type</th>
                <th style={{ minWidth: "140px" }}>Product Name</th>
                <th style={{ minWidth: "140px" }}>Commercial Mode</th>
                <th style={{ minWidth: "140px" }}>Count/Sheet</th>
                <th>Qty</th>
                <th>Quoted</th>
                <th>Discount</th>
                <th>Upselling</th>
                <th style={{ minWidth: "140px" }}>Final Amount</th>
              </tr>
            </thead>
            <tbody>
              {deliverDataTable.length > 0 ? (
                deliverDataTable.map((deliver) => {
                  return (
                    <tr key={deliver._id}>
                      <td>{deliver.sNo}</td>
                      <td
                        className="deliverable-table-button"
                        style={
                          deliver.eventNo.length > 1
                            ? { paddingBottom: "80px", minWidth: "120px" }
                            : { paddingBottom: "42px", minWidth: "120px" }
                        }
                      >
                        {managerView ||
                        qcSentProcessStatus === "PS8" ||
                        qcSentProcessStatus === "PS6" ||
                        qcSentProcessStatus === "PS19" ||
                        qcSentProcessStatus === "PS9" ? (
                          <>
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              disabled
                              onClick={() => {
                                setDeliverModal(true)
                                editDeliverDetails(deliver)
                              }}
                              className="btn btn-success"
                            >
                              <i className="fas fa-edit icon-btn"></i>
                            </Button>
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              onClick={() => {
                                setDeliverModal(true)
                                editDeliverDetails(deliver)
                                setRequestDeliverView(true)
                              }}
                              className="mx-1 btn btn-info"
                            >
                              <i className="fas fa-book icon-btn"></i>
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              onClick={() => {
                                setDeliverModal(true)
                                editDeliverDetails(deliver)
                                setDeliverableRemoveId(deliver._id)
                              }}
                              className="btn btn-success"
                            >
                              <i className="fas fa-edit icon-btn"></i>
                            </Button>
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              onClick={() => {
                                setDeliverableRemoveId(deliver._id)
                                setDeleteDeliverForm(true)
                              }}
                              className="mx-1 btn btn-danger"
                            >
                              <i className="bx bx-block icon-btn"></i>
                            </Button>
                          </>
                        )}
                      </td>
                      <td>{deliver.eventNo}</td>
                      <td style={{ paddingRight: "50px" }}>
                        {deliver.eventName.length > 1
                          ? deliver.eventName + ","
                          : deliver.eventName}
                      </td>
                      <td>{deliver.deliverableType}</td>
                      <td>{deliver.productName}</td>
                      <td>{deliver.commercialMode}</td>
                      <td>
                        {deliver.count === null ? 0 : deliver.count} /{" "}
                        {deliver.sheet === null ? 0 : deliver.sheet}
                      </td>
                      <td className="event-table-value">{deliver.quantity}</td>
                      <td
                        className="event-table-value"
                        style={{ color: "#34c38f" }}
                      >
                        {deliver.actualPrice + ".00"}
                      </td>
                      <td
                        className="event-table-value"
                        style={{ color: "#f1153e" }}
                      >
                        {deliver.discount + ".00"}
                      </td>
                      <td className="event-table-value">
                        {deliver.upselling + ".00"}
                      </td>
                      <td
                        className="event-table-value"
                        style={{ color: "#086fc7" }}
                      >
                        {deliver.finalAmount + ".00"}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <>
                  <tr key={0}>
                    <td colSpan={13} className="text-align-center">
                      No record found
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    fontWeight: "550",
                  }}
                >
                  Total Deliverable Cost
                </td>
                <td className="event-table-value">
                  {deliverDataTable.length > 0 ? deliverQuantityTotal : 0}
                </td>
                <td className="event-table-value" style={{ color: "#34c38f" }}>
                  {deliverDataTable.length > 0
                    ? deliverQuoteTotal + ".00"
                    : "0.00"}
                </td>
                <td className="event-table-value" style={{ color: "#f1153e" }}>
                  {deliverDataTable.length > 0
                    ? deliverDiscountTotal + ".00"
                    : "0.00"}
                </td>
                <td className="event-table-value">
                  {deliverDataTable.length > 0
                    ? deliverUpsellingTotal + ".00"
                    : "0.00"}
                </td>
                <td className="event-table-value" style={{ color: "#086fc7" }}>
                  {deliverDataTable.length > 0
                    ? deliverFinalAmount + ".00"
                    : "0.00"}
                </td>
              </tr>
            </tbody>
            {deleteDeliverForm && (
              <Modal show={deleteDeliverForm} onHide={handleDeliverClose}>
                <Modal.Header>Delete Event Details</Modal.Header>
                <Modal.Body>
                  Are you sure you want to delete the Event details ?
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-danger"
                    onClick={handleDeliverClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="btn btn-success"
                    onClick={() => {
                      handleDeliverClose()
                      removeDeliverDetails()
                    }}
                  >
                    Delete
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </Table>
        </Col>
        <Col md="12" lg="12" xl="12" className="mt-2 event-detail-content">
          {managerView || requestDeliverView ? (
            <>
              {deliverModal && (
                <form>
                  <Row className="event-card-content">
                    <Col className="mt-2 mb-2">
                      <Row className="">
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Events
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            isMulti
                            name="events"
                            isDisabled={true}
                            value={deliverEvent}
                            options={eventDeliverableOptions}
                            onChange={(e) => setDeliverEvent(e)}
                            placeholder="Select Event"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label for="eventList" className="event-label">
                            Deliverable
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="deliverable"
                            value={deliverable}
                            isDisabled={true}
                            onChange={(e) => changeDeliverable(e)}
                            options={
                              deliverablesMetaData
                                ? deliverablesMetaData.deliverablesOptions
                                : []
                            }
                            id="eventList"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Commercial Mode
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="commercialMode"
                            value={commercial}
                            isDisabled={true}
                            onChange={(e) => setCommercial(e)}
                            options={commercialMode}
                            placeholder="Select Mode"
                          />
                        </Col>

                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Product
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="Product"
                            value={product}
                            isDisabled={true}
                            onChange={(e) => changeProduct(e, product)}
                            options={productOptions}
                            placeholder="Select Product"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Sub Product</Label>
                          <Select
                            name="subProduct"
                            value={subproduct}
                            isDisabled={true}
                            onChange={(e) => setSubProduct(e)}
                            options={subProductOptions}
                            placeholder="Select Sub Product"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Photos Count / Detail
                          </Label>
                          <Input
                            type="text"
                            name="count"
                            disabled
                            value={deliverData.count}
                            onChange={(e) => {
                              handleDeliverChange(e)
                            }}
                            placeholder="Enter count"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Sheet Nos / Length(min)
                          </Label>
                          <Input
                            type="text"
                            name="sheetLength"
                            disabled
                            value={deliverData.sheetLength}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Sheet Nos"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Quantity
                            <span className="event-required">*</span>
                          </Label>
                          {/* {checked ? ( */}
                          <Input
                            name="quantity"
                            disabled
                            value={deliverData.quantity}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Quantity"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Quote Price
                            <span className="event-required">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="actualPrice"
                            disabled
                            value={deliverData.actualPrice}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Quote Price"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Final Amount</Label>
                          <Input
                            type="text"
                            name="quotePrice"
                            disabled
                            // disabled={requestView === true ? true : false}
                            value={deliverData.quotePrice}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter final Amount"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Delivery Mode
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="deliveryMode"
                            value={deliveryMode}
                            isDisabled={true}
                            onChange={(e) => setDeliveryMode(e)}
                            options={
                              deliverablesMetaData
                                ? deliverablesMetaData.deliveryModeOptions
                                : []
                            }
                            placeholder="Select Delivery Mode"
                          />
                        </Col>
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column mt-3"
                        >
                          <Label className="event-label">Remarks</Label>
                          <textarea
                            type="text"
                            name="remarks"
                            disabled
                            value={deliverData.remarks}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Remarks"
                            className="event-crowd-textarea"
                          />
                        </Col>
                        {/* Table event */}
                        <Col
                          md="12"
                          xl="12"
                          lg="12"
                          className="event-details-submit mt-3"
                        >
                          <button
                            onClick={() => {
                              setDeliverModal(!deliverModal)
                              // handleCancel()
                              setDeliverData("")
                              setIsEdit(false)
                            }}
                            type="button"
                            className="btn btn-danger btn-label form-cancel-btn"
                          >
                            <i className="bx bx-block label-icon "></i>
                            Cancel
                          </button>
                        </Col>
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column mt-3"
                        >
                          <textarea
                            type="text"
                            name="notes"
                            disabled
                            value={deliverData.notes}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Notes"
                            className="event-crowd-textarea deliver-notes"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              )}
            </>
          ) : (
            <>
              {deliverModal && (
                <form>
                  <Row className="event-card-content">
                    <Col className="mt-2 mb-2">
                      <Row className="">
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Events
                            <span className="event-required">*</span>
                          </Label>
                          {/* <MultiSelect
                            name="events"
                            value={deliverEvent}
                            hasSelectAll={true}
                            options={eventDeliverableOptions}
                            onChange={(e) => setDeliverEvent(e)}
                            labelledBy="Select Event"
                          /> */}
                          <Select
                            isMulti
                            name="events"
                            value={deliverEvent}
                            options={eventDeliverableOptions}
                            onChange={(e) => setDeliverEvent(e)}
                            placeholder="Select Event"
                          />
                          {simpleValidator.current.message(
                            "event",
                            deliverEvent,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label for="eventList" className="event-label">
                            Deliverable
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="deliverable"
                            value={deliverable}
                            onChange={(e) => changeDeliverable(e)}
                            // value={event}
                            options={
                              deliverablesMetaData
                                ? deliverablesMetaData.deliverablesOptions
                                : []
                            }
                            id="eventList"
                          />
                          {simpleValidator.current.message(
                            "deliverable",
                            deliverable,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Commercial Mode
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="commercialMode"
                            value={commercial}
                            onChange={(e) => changeCommercialMode(e)}
                            options={commercialMode}
                            placeholder="Select Mode"
                          />
                          {simpleValidator.current.message(
                            "commercialMode",
                            commercial,
                            "required"
                          )}
                        </Col>

                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Product
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="product"
                            value={product}
                            onChange={(e) => changeProduct(e, product)}
                            // isDisabled={commercial.label === "FREE" ? true : false}
                            options={productOptions}
                            placeholder="Select Product"
                          />
                          {simpleValidator.current.message(
                            "product",
                            product,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Sub Product</Label>
                          <Select
                            name="subProduct"
                            value={subproduct}
                            onChange={(e) => setSubProduct(e)}
                            isDisabled={
                              product.subProductId !== subproduct.value
                                ? true
                                : false
                            }
                            options={subProductOptions}
                            placeholder="Select Sub Product"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Photos Count / Detail
                          </Label>
                          <Input
                            type="text"
                            name="count"
                            disabled={
                              product.count === undefined ? true : false
                            }
                            value={deliverData.count}
                            onChange={(e) => {
                              handleDeliverChange(e)
                            }}
                            placeholder="Enter count"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Sheet Nos / Length(min)
                          </Label>
                          <Input
                            type="text"
                            name="sheetLength"
                            disabled={
                              product.sheet === undefined &&
                              product.length === undefined
                                ? true
                                : false
                            }
                            value={deliverData.sheetLength}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Sheet Nos"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Quantity
                            <span className="event-required">*</span>
                          </Label>
                          {/* {checked ? ( */}
                          <Input
                            name="quantity"
                            // disabled={
                            //   product.defaultQuantity === 0 ? false : true
                            // }
                            value={deliverData.quantity}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Quantity"
                          />

                          {simpleValidator.current.message(
                            "quantity",
                            deliverData.quantity,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Quote Price
                            <span className="event-required">*</span>
                          </Label>
                          {checked ? (
                            <Input
                              type="text"
                              name="actualPrice"
                              disabled
                              value={deliverData.actualPrice}
                              onChange={(e) => handleDeliverChange(e)}
                              placeholder="Enter Quote Price"
                            />
                          ) : (
                            <Input
                              type="text"
                              name="actualPrice"
                              value={deliverData.actualPrice}
                              onChange={(e) => handleDeliverChange(e)}
                              placeholder="Enter Quote Price"
                            />
                          )}
                          {simpleValidator.current.message(
                            "actualPrice",
                            deliverData.actualPrice,
                            "required"
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Final Amount</Label>
                          <Input
                            type="text"
                            name="quotePrice"
                            // disabled={requestView === true ? true : false}
                            value={deliverData.quotePrice}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter final Amount"
                          />
                        </Col>
                        <Col lg="4" md="4" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">
                            Delivery Mode
                            <span className="event-required">*</span>
                          </Label>
                          <Select
                            name="deliveryMode"
                            value={deliveryMode}
                            onChange={(e) => setDeliveryMode(e)}
                            // isDisabled={commercial.label === "FREE" ? true : false}
                            options={
                              deliverablesMetaData
                                ? deliverablesMetaData.deliveryModeOptions
                                : []
                            }
                            placeholder="Select Delivery Mode"
                          />
                          {simpleValidator.current.message(
                            "deliveryMode",
                            deliveryMode,
                            "required"
                          )}
                        </Col>
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column mt-3"
                        >
                          <Label className="event-label">Remarks</Label>
                          <textarea
                            type="text"
                            name="remarks"
                            value={deliverData.remarks}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Remarks"
                            className="event-crowd-textarea"
                          />
                        </Col>
                        {/* Table event */}
                        <Col
                          md="12"
                          xl="12"
                          lg="12"
                          className="event-details-submit mt-3"
                        >
                          {isEdit ? (
                            <>
                              <button
                                onClick={() => {
                                  setDeliverModal(!deliverModal)
                                  setDeliverData("")
                                  setIsEdit(false)
                                  window.scrollTo(0, 1300)
                                }}
                                type="button"
                                className="btn btn-danger btn-label form-cancel-btn"
                              >
                                <i className="bx bx-block label-icon "></i>
                                Cancel
                              </button>
                              <button
                                type="submit"
                                onClick={() => {
                                  setDeliverModal(!deliverModal)
                                  handleDeliverUpdate()
                                  setIsEdit(false)
                                }}
                                className="btn btn-success btn-label form-submit-btn"
                              >
                                <i className="bx bx-check-double label-icon"></i>
                                Update
                              </button>
                            </>
                          ) : (
                            <>
                              {" "}
                              <button
                                onClick={() => {
                                  setDeliverModal(!deliverModal)
                                  window.scrollTo(0, 1300)
                                  forceDeliverUpdate()
                                }}
                                type="button"
                                className="btn btn-danger btn-label form-cancel-btn"
                              >
                                <i className="bx bx-block label-icon "></i>
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  handleDeliverSubmit()
                                  // setDeliverModal()
                                }}
                                className="btn btn-success btn-label form-submit-btn"
                              >
                                <i className="bx bx-check-double label-icon"></i>
                                Submit
                              </button>
                            </>
                          )}
                        </Col>
                        <Col
                          xl="12"
                          lg="12"
                          md="12"
                          sm="12"
                          xs="12"
                          className="d-flex flex-column mt-3"
                        >
                          <textarea
                            type="text"
                            name="notes"
                            value={deliverData.notes}
                            onChange={(e) => handleDeliverChange(e)}
                            placeholder="Enter Notes"
                            className="event-crowd-textarea deliver-notes"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              )}
            </>
          )}
        </Col>
        {/* Special Instructions */}
        <Col md="12" xl="12" lg="12" className="mt-2">
          <Row>
            <Col lg="9" md="9" sm="6" xs="6">
              <p className="special-info">
                Special Instructions
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="specialInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="specialInfo">
                    Special Instructions Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            <Col lg="3" md="3" sm="6" xs="6">
              {managerView ||
              qcSentProcessStatus === "PS8" ||
              qcSentProcessStatus === "PS6" ||
              qcSentProcessStatus === "PS19" ||
              qcSentProcessStatus === "PS9" ? (
                ""
              ) : (
                <div
                  className="add-more-instructions"
                  onClick={() => {
                    addSpecialInstruction()
                  }}
                >
                  Add More
                </div>
              )}
            </Col>
          </Row>
        </Col>
        {specialInstructionSet && (
          <Col md="12" xl="12" lg="12" className="mt-3">
            <Table>
              <tbody>
                <tr>
                  <td style={{ width: "25%" }}>
                    <Select
                      name="department"
                      value={department}
                      options={
                        instructionsMetaData
                          ? instructionsMetaData.departmentOptions
                          : []
                      }
                      placeholder="Select Department"
                      onChange={(e) => setDepartment(e)}
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <Select
                      name="team"
                      value={team}
                      options={
                        instructionsMetaData
                          ? instructionsMetaData.teamOptions
                          : []
                      }
                      placeholder="Select Team"
                      onChange={(e) => setTeam(e)}
                    />
                  </td>
                  <td style={{ width: "20%" }}>
                    <Input
                      name="remarks"
                      value={instructionsList.remarks}
                      onChange={(e) => instructionsChange(e)}
                      placeholder="Test Content"
                    />
                  </td>

                  {updateInstruction ? (
                    <td style={{ width: "15%" }}>
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setUpdateInstruction(false)
                            setSpecialInstructionSet(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-info"
                          onClick={() => updateInstructions()}
                        >
                          update
                        </div>
                      </div>
                    </td>
                  ) : (
                    <td style={{ width: "15%" }} className="w-10">
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setSpecialInstructionSet(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-success"
                          onClick={() => handleInstructions()}
                        >
                          Add
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              </tbody>
            </Table>
          </Col>
        )}
        <Col className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th>Department</th>
                <th>Team</th>
                <th>Special Instructions</th>
                <th className="icon-section" style={{ textAlign: "center" }}>
                  #
                </th>
                <th className="icon-section">#</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(instructions) && instructions.length > 0 ? (
                instructions.map((item) => {
                  return (
                    <>
                      <tr key={item._id}>
                        <td>
                          {!isEmpty(item) && item.departmentName
                            ? item.departmentName
                            : ""}
                        </td>
                        <td>
                          {!isEmpty(item) && item.teamName ? item.teamName : ""}
                        </td>
                        <td>
                          {!isEmpty(item) && item.remarks ? item.remarks : ""}
                        </td>
                        <td>
                          {managerView ||
                          qcSentProcessStatus === "PS8" ||
                          qcSentProcessStatus === "PS6" ||
                          qcSentProcessStatus === "PS19" ||
                          qcSentProcessStatus === "PS9" ? (
                            <button
                              type="submit"
                              className="add-button disabled-button"
                              disabled
                              onClick={() => {
                                editInstructions(item)
                              }}
                            >
                              Edit
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="add-button"
                              onClick={() => {
                                editInstructions(item)
                              }}
                            >
                              Edit
                            </button>
                          )}
                        </td>
                        <td>
                          {managerView ||
                          qcSentProcessStatus === "PS8" ||
                          qcSentProcessStatus === "PS6" ||
                          qcSentProcessStatus === "PS19" ||
                          qcSentProcessStatus === "PS9" ? (
                            <i
                              className="fa fa-times remove-icon disabled-button"
                              onClick={() => {
                                setInstructionsId(item._id)
                                setDeleteInstructionsForm(true)
                              }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-times remove-icon"
                              onClick={() => {
                                setInstructionsId(item._id)
                                setDeleteInstructionsForm(true)
                              }}
                            ></i>
                          )}
                        </td>
                      </tr>
                    </>
                  )
                })
              ) : (
                <>
                  <tr key={0}>
                    <td colSpan={5} className="text-align-center">
                      No record found
                    </td>
                  </tr>
                </>
              )}
              {
                !isEmpty(leadCarryForwardListSpecialInstruction) &&
                  leadCarryForwardListSpecialInstruction.map((item) => {
                    if (item.mode === "followup") {
                      return (
                        <>
                          <tr key={item._id}>
                            <td>
                              {!isEmpty(item) && item.departmentName
                                ? item.departmentName
                                : ""}
                            </td>
                            <td>
                              {!isEmpty(item) && item.teamName
                                ? item.teamName
                                : ""}
                            </td>
                            <td>
                              {!isEmpty(item) && item.remarks
                                ? item.remarks
                                : ""}
                            </td>
                            <td>
                              {!isEmpty(item) && item.mode ? item.mode : ""}
                            </td>
                            <td>
                              <i className="fa fa-times remove-icon disabled-button"></i>
                            </td>
                          </tr>
                        </>
                      )
                    }
                  })
                // : (
                //   <>
                //     <tr key={0}>
                //       <td colSpan={5} className="text-align-center">
                //         No record found
                //       </td>
                //     </tr>
                //   </>
                // )
              }
            </tbody>
          </Table>
        </Col>

        {deleteInstructionsForm && (
          <Modal show={deleteInstructionsForm} onHide={handleInstructionsClose}>
            <Modal.Header>Delete Event Details</Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the Event details ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleInstructionsClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleInstructionsClose()
                  removeSpecialInstruction()
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* PhotoGraphy Event Section */}
        <Col md="12" xl="12" lg="12" className="mt-2">
          <Row>
            <Col lg="9" md="9" sm="6" xs="8">
              <p className="special-info">
                Photography Event Check List
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="photographyInfo"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip
                    placement="right"
                    target="photographyInfo"
                  >
                    Photography Event Description
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
            <Col lg="3" md="3" sm="6" xs="4">
              {managerView ||
              qcSentProcessStatus === "PS8" ||
              qcSentProcessStatus === "PS6" ||
              qcSentProcessStatus === "PS19" ||
              qcSentProcessStatus === "PS9" ? (
                ""
              ) : (
                <div className="add-more-instructions" onClick={addphotography}>
                  Add More
                </div>
              )}
            </Col>
          </Row>
        </Col>

        {photographyCheckList && (
          <Col className="mt-3">
            <Table>
              <tbody>
                <tr>
                  <td style={{ width: "80%" }}>
                    <Input
                      name="description"
                      value={eventCheckList.description}
                      placeholder="Photography Event Checklist"
                      onChange={(e) => checklistChange(e)}
                    />
                  </td>

                  {updateChecklist ? (
                    <td style={{ width: "10%" }}>
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setUpdateChecklist(false)
                            setPhotographyCheckList(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-info"
                          onClick={() => updateChecklists()}
                        >
                          Update
                        </div>
                      </div>
                    </td>
                  ) : (
                    <td style={{ width: "10%" }}>
                      <div className="d-flex flex-row">
                        <div
                          className="add-button btn btn-warning"
                          onClick={() => {
                            setPhotographyCheckList(false)
                          }}
                        >
                          cancel
                        </div>
                        <div
                          className="add-button btn btn-success"
                          onClick={() => handleChecklist()}
                        >
                          Add
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              </tbody>
            </Table>
          </Col>
        )}
        <Col xl="12" lg="12" md="12" className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th> Photography Event Check List Details</th>
                <th className="icon-section" style={{ textAlign: "center" }}>
                  #
                </th>
                <th className="icon-section">#</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(checklist_details) && checklist_details.length > 0 ? (
                checklist_details.map((item) => {
                  return (
                    <tr key={item._id}>
                      <td style={{ width: "84%" }}>
                        {!isEmpty(item) && item.description
                          ? item.description
                          : ""}
                      </td>
                      <td style={{ width: "8%" }}>
                        {managerView ||
                        qcSentProcessStatus === "PS8" ||
                        qcSentProcessStatus === "PS6" ||
                        qcSentProcessStatus === "PS19" ||
                        qcSentProcessStatus === "PS9" ? (
                          <button
                            className="add-button disabled-button"
                            disabled
                            onClick={() => {
                              editChecklists(item)
                            }}
                          >
                            Edit
                          </button>
                        ) : (
                          <button
                            className="add-button"
                            onClick={() => {
                              editChecklists(item)
                            }}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                      <td style={{ width: "8%" }}>
                        {managerView ||
                        qcSentProcessStatus === "PS8" ||
                        qcSentProcessStatus === "PS6" ||
                        qcSentProcessStatus === "PS19" ||
                        qcSentProcessStatus === "PS9" ? (
                          <i
                            className="fa fa-times remove-icon disabled-button"
                            onClick={() => {
                              setEventCheckListId(item._id)
                              setDeleteChecklistForm(true)
                            }}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-times remove-icon"
                            onClick={() => {
                              setEventCheckListId(item._id)
                              setDeleteChecklistForm(true)
                            }}
                          ></i>
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <>
                  <tr key={0}>
                    <td colSpan={3} className="text-align-center">
                      No record found
                    </td>
                  </tr>
                </>
              )}
              {
                !isEmpty(leadCarryForwardListCheckList) &&
                  leadCarryForwardListCheckList.map((item) => {
                    if (item.mode === "followup") {
                      return (
                        <tr key={item._id}>
                          <td style={{ width: "84%" }}>
                            {!isEmpty(item) && item.description
                              ? item.description
                              : ""}
                          </td>
                          <td style={{ width: "8%" }}>
                            {!isEmpty(item) && item.mode ? item.mode : ""}
                          </td>
                          <td>
                            <i className="fa fa-times remove-icon disabled-button"></i>
                          </td>
                        </tr>
                      )
                    }
                  })
                // : (
                //   <>
                //     <tr key={0}>
                //       <td colSpan={3} className="text-align-center">
                //         No record found
                //       </td>
                //     </tr>
                //   </>
                // )
              }
            </tbody>
          </Table>
          {deleteChecklistForm && (
            <Modal show={deleteChecklistForm} onHide={handleChecklistClose}>
              <Modal.Header>Delete Event Details</Modal.Header>
              <Modal.Body>
                Are you sure you want to delete the Event details ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleChecklistClose}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handleChecklistClose()
                    removePhotography()
                  }}
                >
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {/* Preview Modal */}
          {openPreviewModal && (
            <Modal
              show={openPreviewModal}
              size={"lg"}
              onHide={handlePreviewModalClose}
            >
              <Modal.Header>Preview Details</Modal.Header>
              <Modal.Body>
                <Col md="12" lg="12" xl="12">
                  <center>
                    <Nav className="nav">
                      {qc_layout_master && qc_layout_master.length > 0
                        ? qc_layout_master.map((item, index) => {
                            return (
                              <>
                                <button
                                  key={index}
                                  type="button"
                                  className={
                                    activeTab === item.layoutName
                                      ? "btn btn-success"
                                      : "btn btn-info"
                                  }
                                  style={{
                                    marginRight: "20px",
                                    marginTop: "10px",
                                  }}
                                  onClick={() => {
                                    qCLayoutMasterChange(item._id)
                                    setActiveTab(item.layoutName)
                                  }}
                                >
                                  {item.layoutName}
                                </button>
                              </>
                            )
                          })
                        : ""}
                    </Nav>
                  </center>
                </Col>

                <hr />

                <Col xl="12" lg="12" md="12" className="mt-3 mb-3">
                  <Row>
                    {segmentByCategory && segmentByCategory.length > 0 ? (
                      segmentByCategory.map((item, index) => {
                        return (
                          <>
                            <Col
                              lg="3"
                              md="6"
                              sm="6"
                              xs="12"
                              key={index}
                              style={{ marginBottom: "25px" }}
                            >
                              <div
                                className="value-content"
                                style={{ padding: "18px" }}
                              >
                                <h2 className="value-title">
                                  {item.segmentName}
                                </h2>
                                <h1 className="value-total">
                                  <input
                                    name={"segment_" + item.key}
                                    type="checkbox"
                                    style={{ fontSize: "16px" }}
                                    value={item.id}
                                    checked={
                                      item.id === segmentCheckBoxCheckedValue
                                    }
                                    className={"mt-1 event-given-input segment"}
                                    onClick={() => {
                                      qCLayoutSegmentChange(item)
                                    }}
                                  />
                                </h1>
                              </div>
                            </Col>
                            <br />
                          </>
                        )
                      })
                    ) : (
                      <p>{"No Data Found"}</p>
                    )}
                  </Row>
                </Col>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handlePreviewModalClose}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handlePreviewModalSubmit()
                  }}
                >
                  Preview
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {/* Preview Submit modal */}

          {openPreviewSubmitModal && (
            <Modal
              show={openPreviewSubmitModal}
              size={"lg"}
              onHide={handlePreviewModalSubmitClose}
            >
              <Modal.Header>Preview Selected Details Details</Modal.Header>
              <Modal.Body>
                <Col xl="12" lg="12" md="12" className="mt-3 mb-3">
                  <Row>
                    {segmentByCategory && segmentByCategory.length > 0 ? (
                      segmentByCategory.map((item, index) => {
                        return (
                          <>
                            <Col
                              lg="3"
                              md="6"
                              sm="6"
                              xs="12"
                              key={index}
                              style={{ marginBottom: "25px" }}
                            >
                              <div
                                className="value-content"
                                style={{ padding: "18px" }}
                              >
                                <h2 className="value-title">
                                  {item.segmentName}
                                </h2>
                                <h1 className="value-total">
                                  <Input
                                    name="premium"
                                    type="checkbox"
                                    className="mt-1 event-given-input"
                                    style={{ fontSize: "16px" }}
                                  />
                                </h1>
                              </div>
                            </Col>
                            <br />
                          </>
                        )
                      })
                    ) : (
                      <p>{"No Data Found"}</p>
                    )}
                  </Row>
                </Col>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handlePreviewModalSubmitClose}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => {
                    handlePreviewModalSubmit()
                  }}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </Col>
        {managerView ||
        isQuotation === true ||
        qcSentProcessStatus === "PS6" ||
        qcSentProcessStatus === "PS17" ||
        qcSentProcessStatus === "PS19" ? (
          <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-2 mb-2">
            <button
              type="submit"
              onClick={() => {
                setQuotationUpdateForm(true)
              }}
              disabled={
                qcSentProcessStatus === "PS9" || qcSentProcessStatus === "PS19"
                  ? true
                  : false
              }
              className="btn btn-success btn-label form-submit-btn final-submit"
            >
              <i className="bx bx-check-double label-icon"></i>
              Update
            </button>
          </Col>
        ) : (
          <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-2 mb-2">
            <button
              type="submit"
              onClick={() => {
                setQuotationForm(true)
              }}
              className="btn btn-success btn-label form-submit-btn final-submit"
            >
              <i className="bx bx-check-double label-icon"></i>
              Submit
            </button>
          </Col>
        )}

        {quotationForm && (
          <Modal show={quotationForm} onHide={handleQuotationClose}>
            <Modal.Header>Update Quotation Details</Modal.Header>
            <Modal.Body>
              Are you sure, you want to update quotation details ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleQuotationClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleQuotationSubmit()
                  handleQuotationClose()
                }}
              >
                {isQuotation === true ? "Update" : "Submit"}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {quotationUpdateForm && (
          <Modal show={quotationUpdateForm} onHide={handleQuotationUpdateClose}>
            <Modal.Header>Update Quotation Details</Modal.Header>
            <Modal.Body>
              Are you sure, you want to update quotation details ?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleQuotationUpdateClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  handleQuotationUpdate()
                  handleQuotationUpdateClose()
                }}
              >
                {"Update"}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {quotationLoading ? (
          <Modal
            show={quotationLoading}
            style={{ width: "10%", margin: "20% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
              />
              <span>Loading...</span>
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
        {discountCheckedModal ? (
          <Modal
            show={discountCheckedModal}
            size="md"
            // style={{ width: "10%", margin: "20% 50%" }}
          >
            <Modal.Header
              style={{
                backgroundColor: "#e40d8c",
                color: "#ffffff",
                fontWeight: 600,
              }}
            >
              Discount
            </Modal.Header>
            <Modal.Body>{`Do you want to ${
              discountChecked === true ? "check" : "uncheck"
            } the discount preview ?`}</Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleDiscountChecked}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => {
                  // handleQuotationUpdate()
                  handleDiscountDetails()
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
        ) : (
          ""
        )}
      </Row>
    </React.Fragment>
  )
}

QuotationDetails.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  record_event_details: PropTypes.array,
  deliverable_details: PropTypes.array,
  instructions: PropTypes.array,
  checklist_details: PropTypes.array,
  service_details: PropTypes.array,
  sales_details: PropTypes.array,
  qc_history: PropTypes.array,
  location: PropTypes.array,
  service_total_account: PropTypes.array,
  quotationList: PropTypes.array,
  clientProfile: PropTypes.array,
  recordArray: PropTypes.array,
  loginAccess: PropTypes.array,
  recordsMetaData: PropTypes.object,
  quotationRecordsMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  clientId: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}
const mapStateToProps = (state) => ({
  quotationProps: state.quotation.record_quotation_details,
  eventProps: state.Event.record_event_details,
  deliver: state.quotation.deliverable_details,
  instructions: state.quotation.instructions,
  checklist_details: state.quotation.checklist_details,
  sales_details: state.quotation.sales_details,
  qc_history: state.quotation.qc_history,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuotationDetails)
)
